<template>
  <div class="audit content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="content__box">
          <div class="content__box__body">
            <span
              class="text-white txt--ss opacity--50 cursor-pointer"
              v-if="admin_access"
              @click="changeUser"
            >
              {{ admin_text }}
            </span>
            <div class="d-flex align-items-center flex-wrap">
              <div class="order-1">
                <p class="text-white txt--ss opacity--50">Audits</p>
              </div>

              <!-- PROPERTY DROPDOWN -->
              <div class="filterReport mt-2 mt-sm-0 ml-0 ml-sm-5 order-3 order-sm-2">
                <p class="txt--ss opacity--50 cursor-default">Property:</p>
                <div class="filter__dropdown ml-3" @mouseover="showDropDown(1)" @click="showDropDown(1);preventClose($event);">
                  <p
                    class="txt--ss txt--primary cursor-pointer alignment-report"
                  >
                    {{
                      selected_property_name
                        ? selected_property_name
                        : "Select Property"
                    }}
                  </p>

                  <div
                    class="filter__items"
                    v-show="show_property_dropdown"
                    v-click-outside="closeDropdown"
                  >
                    <div class>
                      <input
                        type="text"
                        placeholder="Find property"
                        aria-label="Search"
                        class="input__field"
                        v-model="searchProperty"
                        @keyup="getAllProperty"
                      />
                      <div class="mt-3">
                        <div class="top__filter">
                          <ul class="top__filter__ul">
                            <li class="cursor-default">Property</li>
                          </ul>
                          <ul
                            class="top__filter__ul"
                            v-if="selected_property_id != ''"
                          >
                            <li
                              id="clear_filter_property"
                              @click="clearPropertyFilter()"
                            >
                              Clear {{ $t("Filter") }}
                            </li>
                            <!-- <li>None</li> -->
                          </ul>
                        </div>
                        <div
                          class="propertyFilters"
                          v-if="property_list.length > 0"
                        >
                          <p
                            class="
                              txt--primary txt--ss
                              my-3
                              txt--semi-bold
                              cursor-pointer
                            "
                            v-for="(p, index) in property_list"
                            :key="index"
                          >
                            <span
                              class="cursor-pointer property_item"
                              @click="getAuditsForProperty(p)"
                            >
                              {{
                                p.property_name != ""
                                  ? p.property_name
                                  : p.address.split(",")[0]
                              }}
                            </span>
                          </p>
                        </div>
                        <div
                          class="propertyFilters d-flex justify-content-center"
                          v-else
                        >
                          <p class="txt--primary txt--ss my-3 txt--semi-bold">
                            No Property Found
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- DATE RANGE PICKER -->
              <div class="dateSlider ml-0 ml-sm-5 order-2 order-sm-3">
                <span
                  class="txt-s opacity--50 cursor-pointer"
                  @click="getPreviousDateRange()"
                >
                  <i class="fas fa-chevron-left"></i>
                </span>
                <div
                  class="
                    date-range-time-class date-range-time-class-audit
                    d-flex
                    align-items-center
                  "
                >
                  <VueCtkDateTimePicker
                    class="date__range__input mx-2"
                    v-model="from_date"
                    :range="false"
                    format="YYYY-MM-DD HH:mm"
                    formatted="MMM D, YYYY hh:mm a"
                    minute-interval="1"
                    :no-label="true"
                    :only-date="false"
                    :dark="true"
                    :no-button="false"
                    :no-button-now="true"
                    input-size="sm"
                    :noClearButton="true"
                    :error="false"
                    color="#f5a621"
                    :no-shortcuts="true"
                    :max-date="to_date"
                    :min-date="minDate"
                    id="audit_top_filter_1"
                    @validate="getAuditsForDate"
                  ></VueCtkDateTimePicker>
                  <span class="txt-s opacity--50 cursor-pointer separator">
                    -
                  </span>
                  <VueCtkDateTimePicker
                    class="date__range__input mx-2"
                    v-model="to_date"
                    :range="false"
                    format="YYYY-MM-DD HH:mm"
                    formatted="MMM D, YYYY hh:mm a"
                    minute-interval="1"
                    :no-button="false"
                    :no-button-now="true"
                    :no-label="true"
                    :only-date="false"
                    :dark="true"
                    input-size="sm"
                    :noClearButton="true"
                    :error="false"
                    color="#f5a621"
                    :no-shortcuts="true"
                    :max-date="maxDate"
                    :min-date="from_date"
                    id="audit_top_filter_2"
                    @validate="getAuditsForDate"
                  ></VueCtkDateTimePicker>
                </div>
                <span
                  class="txt-s opacity--50 cursor-pointer"
                  @click="getNextDateRange()"
                >
                  <i class="fas fa-chevron-right"></i>
                </span>
              </div>
              <!-- Timezone Filter -->
              <div class="filterReport mt-3 mt-sm-0 ml-0 ml-sm-5 order-4">
                <p class="txt--ss opacity--50 cursor-default">Time zone:</p>
                <div class="filter__dropdown ml-3" @mouseover="showTimezoneDropdown = true"
                  @click.stop="showTimezoneDropdown = true">
                  <p class="txt--ss cursor-pointer alignment-report">
                    <span class="ml-1 txt--primary txt--ss my-3 txt--semi-bold">
                      {{selected_time_zone}}
                    </span>
                  </p>
                  <div class="filter__items" v-show="showTimezoneDropdown"
                    @mouseleave="showTimezoneDropdown = false"
                    v-click-outside="closeTimezoneDropdown">
                    <div>
                      <div class="px-3">
                        <div class="propertyFilters" v-if="time_zone_list.length > 0">
                          <p class="txt--primary txt--ss my-3 txt--semi-bold cursor-pointer" v-for="(time_zone, index) in time_zone_list" :key="index">
                            <span @click="setReportTimezone(time_zone)">
                              {{time_zone}}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Mark As Correct/No Plate -->
              <div class="order-4 ml-auto d-flex justify-content-between">
                <p
                  class="txt--primary txt--ss cursor-pointer"
                  v-if="selected_audit_ids.length > 0"
                  @click="markAuditBulk"
                >
                  Mark Audits
                </p>
                <p class="txt--primary txt--ss cursor-pointer ml-2"
                   v-if="booking_id_list.length >0"
                   @click="deleteBulkSession"
                >Delete Session</p>
              </div>
              <!-- Selected Merge Candidates Section -->
              <div class="order-5 ml-auto" v-if="merge_candidates.length > 0">
                <p
                  class="txt--primary txt--ss cursor-pointer"
                  @click="show_merge_section = true"
                >
                  Selected Merge Candidates({{ merge_candidates.length }})
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- :class="[
              !showAuditdetails && !show_merge_section
                ? 'col-lg-12'
                : 'col-lg-8',
              'mt-4',
            ]" -->
          <div class="col-lg-8 mt-4">
            <div class="content__box">
              <div class="content__box__header">
                <div class="content__box__header__audit__filter">
                  <div>
                    <p class="text-white txt--ss opacity--50">
                      <!-- {{ selected_property_name }} -->
                      {{ audit_pagination.to + "/" + audit_pagination.total }}
                    </p>
                  </div>

                  <div class="audit__filter__links">
                    <p class="text-white txt--ss opacity--50">Filter by:</p>
                    <ul class="audit__filter__links__lists">
                      <!-- Camera Filter -->
                      <li
                        :class="{ active: camera_filter_selected }"
                        @mouseover="showDropDown(2)"
                        @click="
                          showDropDown(2);
                          preventClose($event);
                        "
                      >
                        <p>Camera</p>

                        <div
                          class="filter__items"
                          v-show="show_camera_dropdown"
                          v-click-outside="closeDropdown"
                        >
                          <div class>
                            <input
                              type="text"
                              placeholder="Find Camera"
                              aria-label="Search"
                              class="input__field"
                              v-model="camera_search"
                            />
                            <div class="mt-3">
                              <div class="top__filter mb-2">
                                <ul class="top__filter__ul">
                                  <li class="cursor-default">Camera</li>
                                </ul>
                                <ul
                                  class="top__filter__ul"
                                  v-if="selected_camera_id"
                                >
                                  <li
                                    id="clear_filter_camera"
                                    @click="clearFilter"
                                  >
                                    Clear
                                  </li>
                                </ul>
                              </div>
                              <div
                                class="propertyFilters"
                                v-if="camera_list.length > 0"
                              >
                                <p
                                  class="
                                    txt--ss
                                    my-3
                                    txt--semi-bold txt--off-white
                                    cursor-pointer
                                  "
                                  v-for="(camera, index) in camera_list"
                                  :key="index"
                                >
                                  <span
                                    :class="[
                                      camera.camera_id == selected_camera_id
                                        ? 'txt--primary'
                                        : '',
                                      'cursor-pointer camera_item',
                                    ]"
                                    @click="selectCameraId(camera)"
                                  >
                                    {{ camera.camera_name }}
                                  </span>
                                </p>
                                <infinite-loading
                                  @infinite="camera_paginate"
                                  :distance="10"
                                  v-if="
                                    camera_list.length > 0 && camera_load_more
                                  "
                                >
                                  <div slot="spinner">
                                    <div
                                      class="d-flex justify-content-center mt-4"
                                    >
                                      <div class="lds-ring">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div slot="no-more"></div>
                                  <div slot="no-results">No data found</div>
                                </infinite-loading>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <!-- Plate Filter -->
                      <li
                        :class="{ active: plate_filter_selected }"
                        @mouseover="showDropDown(3)"
                        @click="showDropDown(3)"
                      >
                        <p>Plate</p>

                        <div
                          class="filter__items"
                          v-show="show_plate_dropdown"
                          v-click-outside="closeDropdown"
                        >
                          <div>
                            <!-- <input
                              type="text"
                              placeholder="Find property"
                              aria-label="Search"
                              class="input__field"
                            /> -->
                            <div class="mt-3">
                              <div class="top__filter">
                                <ul class="top__filter__ul">
                                  <li class="cursor-default">
                                    Filter By Plate
                                  </li>
                                </ul>
                                <!-- <ul class="top__filter__ul">
                                  <li>None</li>
                                </ul> -->
                              </div>
                              <div class="propertyFilters">
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_plate_filter == 0
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByPlate(0)"
                                >
                                  <span class="cursor-pointer"> All </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_plate_filter == 1
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByPlate(1)"
                                >
                                  <span class="cursor-pointer">
                                    With plate
                                  </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_plate_filter == 2
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByPlate(2)"
                                >
                                  <span class="cursor-pointer">
                                    Without plate
                                  </span>
                                </p>
                                <!-- <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_plate_filter == 3
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByPlate(3)"
                                >
                                  <span class="cursor-pointer"> No plate </span>
                                </p> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <!-- Filter By Session Type -->
                      <li
                        :class="{ active: customer_filter_selected }"
                        @mouseover="showDropDown(4)"
                        @click="showDropDown(4)"
                      >
                        <p>Customer</p>

                        <div
                          class="filter__items"
                          v-show="show_customer_dropdown"
                          v-click-outside="closeDropdown"
                        >
                          <div>
                            <!-- <input
                              type="text"
                              placeholder="Find property"
                              aria-label="Search"
                              class="input__field"
                            /> -->
                            <div class="mt-3">
                              <div class="top__filter">
                                <ul class="top__filter__ul">
                                  <li class="cursor-default">
                                    Filter By Customer Type
                                  </li>
                                </ul>
                                <!-- <ul class="top__filter__ul">
                                  <li>None</li>
                                </ul> -->
                              </div>
                              <div class="propertyFilters">
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_customer_filter == 0
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByCustomer(0)"
                                >
                                  <span class="cursor-pointer"> All </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_customer_filter == 1
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByCustomer(1)"
                                >
                                  <span class="cursor-pointer">
                                    Anonymous
                                  </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_customer_filter == 2
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByCustomer(2)"
                                >
                                  <span class="cursor-pointer">
                                    Transient
                                  </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_customer_filter == 3
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByCustomer(3)"
                                >
                                  <span class="cursor-pointer"> Permit </span>
                                </p>
                                <!-- <p
                                  class="txt--primary txt--ss my-3 txt--semi-bold cursor-pointer"
                                >
                                  <span class="cursor-pointer">
                                    Without customer
                                  </span>
                                </p> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <!-- Session Filter -->
                      <li
                        :class="{ active: session_filter_selected }"
                        @mouseover="showDropDown(5)"
                        @click="showDropDown(5)"
                      >
                        <p>Session</p>

                        <div
                          class="filter__items"
                          v-show="show_session_dropdown"
                          v-click-outside="closeDropdown"
                        >
                          <div>
                            <!-- <input
                              type="text"
                              placeholder="Find property"
                              aria-label="Search"
                              class="input__field"
                            /> -->
                            <div class="mt-3">
                              <div class="top__filter">
                                <ul class="top__filter__ul">
                                  <li class="cursor-default">
                                    Filter By Sessions
                                  </li>
                                </ul>
                                <!-- <ul class="top__filter__ul">
                                  <li>None</li>
                                </ul> -->
                              </div>
                              <div class="propertyFilters">
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_session_filter == 0
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterBySessions(0)"
                                >
                                  <span class="cursor-pointer"> All </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_session_filter == 1
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterBySessions(1)"
                                >
                                  <span class="cursor-pointer">
                                    Without session
                                  </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_session_filter == 2
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterBySessions(2)"
                                >
                                  <span class="cursor-pointer">
                                    Open sessions
                                  </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_session_filter == 3
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterBySessions(3)"
                                >
                                  <span class="cursor-pointer">
                                    Closed sessions
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <!-- Session Manage Filter -->
                      <li
                        v-if="admin"
                        :class="{ active: session_managed_selected }"
                        @mouseover="showDropDown(6)"
                        @click="showDropDown(6)"
                      >
                        <p>Session Managed</p>

                        <div
                          class="filter__items"
                          v-show="show_manage_session_dropdown"
                          v-click-outside="closeDropdown"
                        >
                          <div>
                            <!-- <input
                              type="text"
                              placeholder="Find property"
                              aria-label="Search"
                              class="input__field"
                            /> -->
                            <div class="mt-3">
                              <div class="top__filter">
                                <ul class="top__filter__ul">
                                  <li class="cursor-default">
                                    Filter By Sessions Managed
                                  </li>
                                </ul>
                                <!-- <ul class="top__filter__ul">
                                  <li>None</li>
                                </ul> -->
                              </div>
                              <div class="propertyFilters">
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_session_managed == 0
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByManagedSessions(0)"
                                >
                                  <span class="cursor-pointer"> All </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_session_managed == 1
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByManagedSessions(1)"
                                >
                                  <span class="cursor-pointer">
                                    Managed Sessions
                                  </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_session_managed == 2
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByManagedSessions(2)"
                                >
                                  <span class="cursor-pointer">
                                    Non Managed Session
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <!-- File Filter -->
                      <li
                        v-if="admin"
                        :class="{ active: image_filter_selected }"
                        @mouseover="showDropDown(7)"
                        @click="showDropDown(7)"
                      >
                        <p>Images</p>

                        <div
                          class="filter__items"
                          v-show="show_image_filter_dropdown"
                          v-click-outside="closeDropdown"
                        >
                          <div>
                            <div class="mt-3">
                              <div class="top__filter">
                                <ul class="top__filter__ul">
                                  <li class="cursor-default">
                                    Filter By Image
                                  </li>
                                </ul>
                              </div>
                              <div class="propertyFilters">
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_image_filter == 0
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByImage(0)"
                                >
                                  <span class="cursor-pointer"> All </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_image_filter == 1
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByImage(1)"
                                >
                                  <span class="cursor-pointer">
                                    Images from the audit tool
                                  </span>
                                </p>
                                <p
                                  :class="[
                                    'txt--ss my-3 txt--semi-bold cursor-pointer',
                                    selected_image_filter == 2
                                      ? 'txt--primary'
                                      : 'txt--off-white',
                                  ]"
                                  @click="filterByImage(2)"
                                >
                                  <span class="cursor-pointer">
                                    Images from not the audit tool
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- Text Search -->
                  <div class="audit__filter__isearch__input">
                    <input
                      type="text"
                      placeholder="Search"
                      aria-label="Search"
                      class="input__field"
                      v-model="search"
                    />
                  </div>
                </div>
              </div>
              <div class="content__divider"></div>
              <div class="content__box__body">
                <div
                  class="table-responsive"
                  style="max-height: 515px; overflow-y: auto"
                >
                  <table class="table table__audit table-borderless">
                    <thead>
                      <tr>
                        <th v-if="admin">
                          <input
                            type="checkbox"
                            name=""
                            id=""
                            :checked="check_all_audits ? true : false"
                            @change="select_all"
                          />
                        </th>
                        <th>
                          Time
                          <span
                            class="pl-1"
                            @click="sortBy(1, 'DESC')"
                            v-if="sort_by == 1 && sort_type == 'ASC'"
                            ><i class="fas fa-angle-up"></i
                          ></span>
                          <span
                            class="pl-1"
                            @click="sortBy(1, 'ASC')"
                            v-if="sort_by == 1 && sort_type == 'DESC'"
                            ><i class="fas fa-angle-down"></i
                          ></span>
                        </th>
                        <th>Camera</th>
                        <th>Orientation</th>
                        <th>Plate</th>
                        <th v-if="admin">Confidence</th>
                        <th v-if="admin">Accurate</th>
                        <th v-if="admin">Correction</th>
                        <th>Customer</th>
                        <th>Session</th>
                      </tr>
                    </thead>
                    <tbody v-if="audit_list.length > 0">
                      <tr
                        v-for="(audit, index) in audit_list"
                        :key="index"
                        :class="[
                          selected_audit_index == index && showAuditdetails
                            ? 'selected'
                            : '',
                        ]"
                      >
                        <td v-if="admin">
                          <input
                            type="checkbox"
                            name=""
                            @change="checkAudit(audit)"
                            id=""
                            :checked="
                              selected_audit_ids.indexOf(audit.id) !== -1
                            "
                          />
                        </td>
                        <td @click="auditDetails(index)">
                          {{ dateFormated(audit.image_time) }}
                        </td>
                        <td @click="auditDetails(index)">
                          {{ audit.camera_name }}
                        </td>
                        <td @click="auditDetails(index)">
                          {{
                            audit.camera_orientation != ""
                              ? audit.camera_orientation
                                  .charAt(0)
                                  .toUpperCase() +
                                audit.camera_orientation.slice(1).toLowerCase()
                              : "Unknown"
                          }}
                        </td>
                        <td v-if="admin" @click="auditDetails(index)">
                          {{
                            audit.license != ""
                              ? audit.license
                              : "—" | uppercase
                          }}
                        </td>
                        <td v-else @click="auditDetails(index)">
                          {{
                            audit.correct_license && audit.correct_license != ""
                              ? audit.correct_license == "NO PLATE"
                                ? "—"
                                : audit.correct_license
                              : audit.license != ""
                              ? audit.license
                              : "—" | uppercase
                          }}
                        </td>
                        <td v-if="admin" @click="auditDetails(index)">
                          {{
                            audit.confidence != ""
                              ? (audit.confidence * 100).toFixed(2) + "%"
                              : "—"
                          }}
                        </td>
                        <td v-if="admin" @click="auditDetails(index)">
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 13 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            v-if="audit.correct != '' && audit.correct == 1"
                          >
                            <circle
                              cx="6.5"
                              cy="6.5"
                              r="6.5"
                              fill="#EF5355"
                              v-if="audit.correction_needed == 1"
                            />
                            <circle
                              cx="6.5"
                              cy="6.5"
                              r="6.5"
                              fill="#42B370"
                              v-else
                            />
                            <path
                              d="M4 9.00004L8.94975 4.05029"
                              stroke="white"
                              stroke-linecap="round"
                              v-if="audit.correction_needed == 1"
                            />
                            <path
                              d="M8.94971 9.00004L3.99996 4.05029"
                              stroke="white"
                              stroke-linecap="round"
                              v-if="audit.correction_needed == 1"
                            />
                            <path
                              d="M2.5 6.50004L5 9.00004L9.94975 4.05029"
                              stroke="white"
                              stroke-linecap="round"
                              v-if="audit.correction_needed != 1"
                            />
                          </svg>
                          <span v-else> — </span>
                        </td>
                        <td v-if="admin" @click="auditDetails(index)">
                          {{
                            audit.correct_license && audit.correct_license != ""
                              ? audit.correct_license
                              : "—" | uppercase
                          }}
                        </td>
                        <td @click="auditDetails(index)">
                          {{
                            audit.booking_type == "anonymous"
                              ? "Anonymous"
                              : audit.booking_type == "transient"
                              ? "Transient"
                              : audit.booking_type == "monthly" ||  audit.booking_type == "permit"
                              ? "Permit"
                              : "—"
                          }}
                        </td>
                        <td
                          @click="
                            openSessionDetails(
                              audit.booking_id,
                              audit.start_time_less_booking,
                              audit.booking_cancelled
                            )
                          "
                        >
                          {{
                            audit.booking_no != ""
                              ? audit.booking_no
                              : audit.session_managed === 0
                              ? "Not Recognized Yet"
                              : "—"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="9" v-if="this.audit_list_end == true">
                          <p
                              class="
                                d-flex
                                justify-content-center
                                align-items-center
                                txt--primary
                              "
                            >
                              End of Reports
                          </p>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else-if="audit_list_loader == true">
                      <tr class="cursor-default">
                        <td colspan="9">
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else-if="audit_list_loader == false && audit_list.length == 0">
                      <tr class="cursor-default">
                        <td colspan="9">
                          <p
                              class="
                                d-flex
                                justify-content-center
                                align-items-center
                                txt--primary
                              "
                            >
                              No Data Found
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <infinite-loading
                    @infinite="paginate"
                    :distance="10"
                    v-if="audit_list.length > 0 && audit_pagination.load_more"
                  >
                    <div slot="spinner">
                      <div class="d-flex justify-content-center mt-4">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div slot="no-more"></div>
                    <div slot="no-results">No data found</div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mt-4">
            <!-- Report Section -->
            <div
              class="graph__area"
              v-if="!showAuditdetails && !show_merge_section"
            >
              <!-- CAPTURE/RECOGNITIONS CHART -->
              <div class="content__box content__box--graph">
                <!--- restricted --->
                <div class="content__box__header">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <li
                        :class="{ active: !show_recognition_chart }"
                        v-if="admin"
                        @click="showChart('capture')"
                      >
                        Captures
                      </li>
                      <li
                        :class="{ active: show_recognition_chart }"
                        @click="showChart('recognition')"
                      >
                        Recognitions
                      </li>
                    </ul>
                  </div>

                  <div v-if="!recognition_chart_loading">
                    <h2 class="primaryHeader">
                      {{ recognition_capture_chart_total }}
                    </h2>
                    <p
                      :class="[
                        'transient-customers-records txt--ss mt-3',
                        percentage_recognition_capture.indexOf('+') != -1
                          ? 'txt--green'
                          : 'txt--red',
                      ]"
                    >
                      <span
                        :class="[
                          percentage_recognition_capture.indexOf('+') != -1
                            ? 'txt--green'
                            : 'txt--red',
                          'rounded-circle',
                        ]"
                      ></span>
                      {{ percentage_recognition_capture }}%
                    </p>
                  </div>
                </div>

                <div v-if="!recognition_chart_loading">
                  <CaptureChart :data="recognition_capture_chart_data" />
                </div>
                <div v-else class="content__box__body responsive__height pt-0">
                  <div class="d-flex justify-content-center">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="content__box content__box--graph mt-4">
                <!--- restricted --->
                <div class="content__box__header">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                      <li
                        :class="{ active: !show_accuracy_chart }"
                        v-if="admin"
                        @click="showChart('confidence')"
                      >
                        Confidence
                      </li>
                      <li
                        :class="{ active: show_accuracy_chart }"
                        @click="showChart('accuracy')"
                      >
                        Accuracy
                      </li>
                    </ul>
                  </div>
                  <div v-if="!accuracy_chart_loading">
                    <h2 class="primaryHeader">
                      {{ accuracy_confidence_chart_total }}%
                    </h2>
                    <p
                      :class="[
                        'transient-customers-records txt--ss mt-3',
                        percentage_accuracy_confidence.indexOf('+') != -1
                          ? 'txt--green'
                          : 'txt--red',
                      ]"
                    >
                      <span
                        :class="[
                          percentage_accuracy_confidence.indexOf('+') != -1
                            ? 'txt--green'
                            : 'txt--red',
                          'rounded-circle',
                        ]"
                      ></span>
                      {{ percentage_accuracy_confidence }}%
                    </p>
                  </div>
                </div>
                <div v-if="!accuracy_chart_loading">
                  <PercentageChart :data="accuracu_confidence_chart_data" />
                </div>
                <div v-else class="content__box__body responsive__height pt-0">
                  <div class="d-flex justify-content-center">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Audit Details Section -->
            <div
              class="audit__session__details h-100"
              v-if="showAuditdetails && !show_merge_section"
            >
              <div class="content__box h-100">
                <div class="content__box__body">
                  <!-- <div class="dateSlider d-inline-flex mb-2">
                    <span class="txt-s opacity--50 cursor-pointer">
                      <i class="fas fa-chevron-left"></i>
                    </span>
                    <span class="txt--primary txt--ss txt--semi-bold mx-2">April 22 - April 29, 2020</span>
                    <VueCtkDateTimePicker
                      class="date__range__input mx-2"
                      v-model="date"
                      :range="true"
                      format="YYYY-MM-DD"
                      formatted="MMM D, YYYY"
                      :no-label="true"
                      :only-date="true"
                      :dark="true"
                      :no-button="true"
                      input-size="sm"
                      :noClearButton="true"
                      :error="false"
                      color="#f5a621"
                      :no-shortcuts="false"
                      :max-date="maxDate"
                      :min-date="minDate"
                    ></VueCtkDateTimePicker>
                    <span
                      class="txt-s opacity--50 cursor-pointer"
                      @click="getNextDateStart()"
                    >
                      <i class="fas fa-chevron-right"></i>
                    </span>
                  </div> -->
                  <p class="d-flex justify-content-between">
                    <span
                      class="text-white txt--ss opacity--50 txt--semi-bold mb-2"
                    >
                      {{
                        audit_details.camera_name != ""
                          ? audit_details.camera_name
                          : ""
                      }}
                      {{
                        audit_details.camera_orientation != ""
                          ? "(" + audit_details.camera_orientation + ")"
                          : ""
                      }}
                    </span>

                    <span
                      class="txt--primary txt--ss cursor-pointer"
                      v-if="
                        admin && 
                        audit_details.booking_id!=''  &&
                        merge_candidates.length < 2 &&
                        merge_session_ids.indexOf(audit_details.booking_id) ==
                          -1
                      "
                      @click="getCandidatesForMerge()"
                    >
                      Merge
                    </span>

                    <span
                      class="txt--primary txt--ss cursor-pointer"
                      v-if="
                        admin &&
                        audit_details.booking_type == 'anonymous' &&
                        (merge_candidates.length == 2 ||
                          merge_session_ids.indexOf(audit_details.booking_id) !=
                            -1) &&
                        (audit_details.start_time_less_booking == 1 ||
                          audit_details.booking_end_time == '')
                      "
                      @click="show_merge_section = true"
                    >
                      View Merge
                    </span>
                  </p>

                  <div
                    class="car__entry__image"
                    v-if="
                      audit_details &&
                      !fetching_image &&
                      audit_details.image != ''
                    "
                  >
                    <!-- <img
                      :src="https://picsum.photos/1920/1080"
                      class="w-100"
                      alt="Image"
                      @error="audit_details.image = ''"
                    /> -->
                    <img
                      :src="audit_details.image"
                      alt="Audit Image"
                      class="w-100 mb-3 cursor-pointer"
                      @click="openImageOnModal(audit_details.image)"
                    />

                    <!-- <button
                      title="Open fullscreen image modal"
                      type="button"
                      class="button button--primary button--sm"
                      @click="openImageOnModal()"
                    >
                      <span>View Image</span>
                    </button> -->
                  </div>
                  <!-- Recognition Details Section -->
                  <div class="recognition__details">
                    <p
                      class="text-white txt--ss opacity--50 txt--semi-bold mb-3"
                    >
                      Recognition Details
                    </p>
                    <div
                      class="form-row mb-4"
                      v-if="
                        audit_details &&
                        audit_details.recognition_data.length > 0
                      "
                    >
                      <!-- Candidates -->
                      <div class="col-md-12">
                        <p class="text-white txt--xs txt--semi-bold mb-3">
                          <span class="opacity--50"> Candidates </span>

                          <span
                            class="ml-2"
                            v-if="
                              audit_details.recognition_data[0].candidates
                                .length == 0
                            "
                          >
                            N/A
                          </span>
                        </p>
                      </div>
                      <div
                        class="col-md-3"
                        v-for="(candidate, index) in audit_details
                          .recognition_data[0].candidates"
                        :key="'candidate_' + index"
                      >
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Plate
                          </p>
                          <p class="txt--fsxs">
                            {{ candidate.plate.toUpperCase() }}
                          </p>
                        </div>
                        <div class="sessionDataTxt" v-if="admin">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Score
                          </p>
                          <p class="txt--fsxs">
                            {{ (candidate.score * 100).toFixed(2) + "%" }}
                          </p>
                        </div>
                      </div>
                      <!-- Color -->
                      <div class="col-md-12 mt-2">
                        <p class="text-white txt--xs txt--semi-bold mb-3">
                          <span class="opacity--50"> Colors </span>

                          <span
                            class="ml-2"
                            v-if="
                              (audit_details.recognition_data[0].color || []).length == 0
                            "
                          >
                            N/A
                          </span>
                        </p>
                      </div>
                      <div
                        class="col-md-3"
                        v-for="(color, index) in (audit_details.recognition_data[0].color || [])"
                        :key="'color_' + index"
                      >
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Color
                          </p>
                          <p class="txt--fsxs">{{ color.color }}</p>
                        </div>
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Score
                          </p>
                          <p class="txt--fsxs">
                            {{ (color.score * 100).toFixed(2) + "%" }}
                          </p>
                        </div>
                      </div>

                      <!-- Make & Model -->
                      <div class="col-md-12 mt-2">
                        <p class="text-white txt--xs txt--semi-bold mb-3">
                          <span class="opacity--50"> Make &amp; Model </span>
                          <span
                            class="ml-2"
                            v-if="
                              (audit_details.recognition_data[0].model_make || [])
                                .length == 0
                            "
                          >
                            N/A
                          </span>
                        </p>
                      </div>
                      <div
                        class="col-md-3"
                        v-for="(model_make, index) in (audit_details.recognition_data[0].model_make || [])"
                        :key="'model_make_' + index"
                      >
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Make
                          </p>
                          <p class="txt--fsxs">{{ model_make.make }}</p>
                        </div>
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Model
                          </p>
                          <p class="txt--fsxs">{{ model_make.model }}</p>
                        </div>
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Score
                          </p>
                          <p class="txt--fsxs">
                            {{ (model_make.score * 100).toFixed(2) + "%" }}
                          </p>
                        </div>
                      </div>

                      <!-- Orientation -->
                      <div class="col-md-12 mt-2">
                        <p class="text-white txt--xs txt--semi-bold mb-3">
                          <span class="opacity--50"> Orientation </span>
                          <span
                            class="ml-2"
                            v-if="
                              (audit_details.recognition_data[0].model_make || [])
                                .length == 0
                            "
                          >
                            N/A
                          </span>
                        </p>
                      </div>
                      <div
                        class="col-md-3"
                        v-for="(orientation, index) in audit_details
                          .recognition_data[0].orientation"
                        :key="'orientation_' + index"
                      >
                        <div class="sessionDataTxt">
                          <p
                            style="width: 50px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Orientation
                          </p>
                          <p class="txt--fsxs">{{ orientation.orientation }}</p>
                        </div>
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Score
                          </p>
                          <p class="txt--fsxs">
                            {{ (orientation.score * 100).toFixed(2) + "%" }}
                          </p>
                        </div>
                      </div>

                      <!-- Other Informations -->
                      <div class="col-md-12 mt-2">
                        <p
                          class="
                            text-white
                            txt--xs
                            opacity--50
                            txt--semi-bold
                            mb-3
                          "
                        >
                          More Info
                        </p>
                      </div>

                      <div class="col-md-3">
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Region
                          </p>
                          <p class="txt--fsxs">
                            {{
                              audit_details.recognition_data[0].region &&
                              audit_details.recognition_data[0].region.code !=
                                "" &&
                              audit_details.recognition_data[0].region.code !=
                                null
                                ? audit_details.recognition_data[0].region.code.toUpperCase()
                                : "N/A"
                            }}
                          </p>
                        </div>
                        <div class="sessionDataTxt">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Score
                          </p>
                          <p class="txt--fsxs">
                            {{
                              audit_details.recognition_data[0].region &&
                              audit_details.recognition_data[0].region.score
                                ? (
                                    audit_details.recognition_data[0].region
                                      .score * 100
                                  ).toFixed(2) + "%"
                                : "N/A"
                            }}
                          </p>
                        </div>
                        <div class="sessionDataTxt" v-if="admin">
                          <p
                            style="width: 40px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Dscore
                          </p>
                          <p class="txt--fsxs">
                            {{
                              (
                                audit_details.recognition_data[0].dscore * 100
                              ).toFixed(2) + "%"
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="sessionDataTxt">
                          <p
                            style="width: 65px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Vehicle Type
                          </p>
                          <p class="txt--fsxs">
                            {{
                              audit_details.recognition_data[0].vehicle &&
                              audit_details.recognition_data[0].vehicle.type
                                ? audit_details.recognition_data[0].vehicle.type
                                : "N/A"
                            }}
                          </p>
                        </div>
                        <div class="sessionDataTxt" v-if="admin">
                          <p
                            style="width: 65px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Score
                          </p>
                          <p class="txt--fsxs">
                            {{
                              (
                                audit_details.recognition_data[0].vehicle
                                  .score * 100
                              ).toFixed(2) + "%"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-row" v-else>
                      <div class="col-md-12">
                        <p
                          class="
                            text-white
                            txt--xs
                            opacity--50
                            txt--semi-bold
                            mb-4
                            mt-4
                            d-flex
                            justify-content-center
                          "
                        >
                          License Plate could not be recognized!
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Correction Section -->
                  <!-- MARK AS CORRECT -->
                  <div class="top__filter" v-if="admin">
                    <ul class="top__filter__ul top__filter__ul--btn">
                      <li
                        :class="{ active: show_correction_form }"
                        @click="showCorrectionForm"
                      >
                        Correction
                      </li>
                      <li @click="markAsCorrect">Mark as Correct</li>
                      <li
                        @click="noPlateCorrection"
                        v-if="
                          audit_details.booking_id == undefined ||
                          audit_details.booking_id == null ||
                          audit_details.booking_id == ''
                        "
                      >
                        No Plate
                      </li>
                      <li
                        v-if="
                          audit_details.booking_id != '' &&
                          audit_details.booking_id!=null &&
                          audit_details.booking_end_time == '' &&
                          audit_details.booking_cancelled == 0 &&
                          audit_details.start_time_less_booking == 0
                        "
                        @click="cancelSession"
                      >
                        Cancel Associated Session
                      </li>
                      <li v-if="(audit_details.booking_id=='' || audit_details.booking_id==null) && audit_details.session_managed==1" @click="confirmReprocess">
                        Reprocess
                      </li>
                    </ul>
                  </div>

                  <!-- CORRECTION FORM -->
                  <div v-if="admin && show_correction_form">
                    <div class="form-row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <p class="txt--fsxs mb-3">
                            <span class="opacity--50"> Enter </span>
                            <span class="text-white txt--semi-bold"
                              >Country</span
                            >
                          </p>
                          <!-- <input
                            type="text"
                            placeholder="Enter country"
                            class="input__field"
                          /> -->
                          <model-list-select
                            :list="country_list"
                            v-model="country_code"
                            option-value="country_code"
                            option-text="country_name"
                            placeholder="Select Country"
                            class="custom-vue-select"
                            :isDisabled="country_disabled"
                          >
                          </model-list-select>
                        </div>
                      </div>
                      <div class="col-sm-6" v-if="state_list.length > 0">
                        <div class="form-group">
                          <p class="txt--fsxs mb-3">
                            <span class="opacity--50"> Enter </span>

                            <span class="text-white txt--semi-bold">State</span>
                          </p>
                          <!-- <input
                            type="text"
                            placeholder="Enter plate"
                            class="input__field"
                          /> -->
                          <model-list-select
                            :list="state_list"
                            v-model="state"
                            option-value="short_code"
                            option-text="full_name"
                            placeholder="Select State"
                            class="custom-vue-select"
                            :isDisabled="state_disabled"
                          >
                          </model-list-select>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <p class="txt--fsxs mb-3">
                            <span class="opacity--50"> Enter </span>

                            <span class="text-white txt--semi-bold">Plate</span>
                          </p>
                          <!-- <input
                            type="text"
                            placeholder="Enter plate"
                            class="input__field"
                          /> -->
                          <model-select
                            :options="candidate_list"
                            v-model="license"
                            placeholder="select License"
                            class="custom-vue-select"
                          >
                          </model-select>
                        </div>
                      </div>
                      <div class="col-sm-6" v-if="show_add_new_license">
                        <div class="form-group">
                          <p class="txt--fsxs mb-3">
                            <span class="opacity--50"> Enter </span>

                            <span class="text-white txt--semi-bold"
                              >Custom Plate</span
                            >
                          </p>
                          <input
                            type="text"
                            placeholder="Enter Custom plate"
                            class="input__field"
                            v-model="selected_license"
                          />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <p class="txt--fsxs mb-3">
                            <span class="opacity--50"> Labels</span>
                          </p>
                          <!-- <input
                            type="text"
                            placeholder="Enter plate"
                            class="input__field"
                          /> -->
                          <vue-tags-input
                            v-model="tag"
                            :tags="tags"
                            @tags-changed="(newTags) => (tags = newTags)"
                            placeholder="Add label"
                            :autocomplete-items="filteredItems"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-center
                        mt-4
                      "
                    >
                      <button
                        type="button"
                        class="button button--primary button--sm mr-3"
                        @click="updateAudit"
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        class="button button--outline button--sm"
                        @click="show_correction_form = false"
                      >
                        Close
                      </button>
                    </div>
                  </div>

                  <!-- CORRECTION HISTORY -->
                  <div
                    class="mt-4"
                    v-if="admin && audit_details.correction_details.length > 0"
                  >
                    <p
                      class="text-white txt--ss opacity--50 txt--semi-bold mb-3"
                    >
                      Correction History
                    </p>
                    <div
                      class="form-row"
                      v-for="(
                        history, index
                      ) in audit_details.correction_details.slice().reverse()"
                      :key="index"
                    >
                      <div class="col-sm-6">
                        <div class="sessionDataTxt">
                          <p
                            style="width: 80px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Corrected By
                          </p>
                          <p class="txt--fsxs">{{ history.admin }}</p>
                        </div>
                        <div
                          class="sessionDataTxt"
                          v-if="history.mark_as_correct != 1"
                        >
                          <p
                            style="width: 80px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Region Code
                          </p>
                          <p class="txt--fsxs">{{ history.region_code }}</p>
                        </div>
                        <div
                          class="sessionDataTxt"
                          v-if="history.mark_as_correct != 1"
                        >
                          <p
                            style="width: 80px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Plate
                          </p>
                          <p class="txt--fsxs">
                            {{
                              history.license
                                ? history.license.toUpperCase()
                                : ""
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="sessionDataTxt">
                          <p
                            style="width: 80px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Corrected At
                          </p>
                          <p class="txt--fsxs">
                            {{ dateFormated(history.correction_at) }}
                          </p>
                        </div>

                        <div
                          class="sessionDataTxt"
                          v-if="history.mark_as_correct != 1"
                        >
                          <p
                            style="width: 80px"
                            class="sessionDataTxt__left txt--fsxs opacity--50"
                          >
                            Tags
                          </p>
                          <p class="txt--fsxs">{{ history.tags.join() }}</p>
                        </div>
                      </div>
                      <div
                        class="
                          col-md-12
                          content__divider
                          pac-item-selected
                          mb-3
                        "
                        v-if="
                          index < audit_details.correction_details.length - 1
                        "
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Merge Session Section -->
            <div
              class="audit__session__details h-100"
              v-if="show_merge_section"
            >
              <div class="content__box h-100">
                <div class="content__box__body">
                  <p class="d-flex justify-content-between mb-4">
                    <span
                      class="text-white txt--ss opacity--50 txt--semi-bold mb-2"
                    >
                      Merge Sessions
                    </span>

                    <span
                      class="
                        text-white
                        txt--ss
                        opacity--50
                        txt--semi-bold
                        mb-2
                        cursor-pointer
                      "
                      @click="show_merge_section = !show_merge_section"
                    >
                      Back
                    </span>
                  </p>

                  <!-- First Merge Candidate Details -->
                  <div>
                    <div
                      class="car__entry__image"
                      v-if="
                        merge_candidates.length > 0 &&
                        merge_candidates[0].image != ''
                      "
                    >
                      <img
                        :src="merge_candidates[0].image"
                        class="w-100"
                        alt="Image"
                        @error="merge_candidates[0].image = ''"
                      />
                    </div>

                    <div class="recognition__details">
                      <p class="d-flex justify-content-between">
                        <span class="text-white txt--ss txt--semi-bold mb-3">
                          {{
                            merge_candidates.length > 0 ? 
                              merge_candidates[0].start_time_less_booking == 1 
                              ? "Start Less Session " 
                              : merge_candidates[0].booking_type == 'anonymous' 
                              ? "Anonymous Session " 
                              : merge_candidates[0].booking_type == 'transient' 
                              ? "Transient Session " 
                              : merge_candidates[0].booking_type == 'monthly' 
                              ? "Permit Session " 
                              : 'Session ' 
                            : "Audit"
                          }}
                          Details
                        </span>

                        <span
                          class="
                            text-white
                            txt--ss
                            opacity--50
                            txt--semi-bold
                            mb-2
                            cursor-pointer
                          "
                          @click="removeCandidates(0)"
                        >
                          Remove
                        </span>
                      </p>
                      <div class="form-row mb-4">
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              Start Time
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0 && merge_candidates[0].booking_start_time!=''
                                  ? dateFormated(merge_candidates[0].booking_start_time)
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              End Time
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0 && merge_candidates[0].booking_end_time!=''
                                  ? dateFormated(merge_candidates[0].booking_end_time)
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              Booking Number
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0
                                  ? merge_candidates[0].booking_no.toUpperCase()
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              Plate
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0
                                  ? merge_candidates[0].booking_made_license.toUpperCase()
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              VIN
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0 &&
                                merge_candidates[0].booking_made_vin
                                  ? merge_candidates[0].booking_made_vin.toUpperCase()
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Divider -->
                  <div
                    class="col-md-12 content__divider pac-item-selected mb-3"
                  ></div>
                  <!-- Second Merge Candidate Details -->
                  <div v-if="merge_candidates.length == 2">
                    <div
                      class="car__entry__image"
                      v-if="
                        merge_candidates.length > 0 &&
                        merge_candidates[1].image != ''
                      "
                    >
                      <img
                        :src="merge_candidates[1].image"
                        class="w-100"
                        alt="Image"
                        @error="merge_candidates[1].image = ''"
                      />
                    </div>

                    <div class="recognition__details">
                      <p class="d-flex justify-content-between">
                        <span class="text-white txt--ss txt--semi-bold mb-3">
                          {{
                            merge_candidates.length > 1 ? 
                              merge_candidates[1].start_time_less_booking == 1 
                              ? "Start Less Session " 
                              : merge_candidates[1].booking_type == 'anonymous' 
                              ? "Anonymous Session " 
                              : merge_candidates[1].booking_type == 'transient' 
                              ? "Transient Session " 
                              : merge_candidates[1].booking_type == 'monthly' 
                              ? "Permit Session " 
                              : 'Session ' 
                            : "Audit"
                          }}
                          Details
                        </span>

                        <span
                          class="
                            text-white
                            txt--ss
                            opacity--50
                            txt--semi-bold
                            mb-2
                            cursor-pointer
                          "
                          @click="removeCandidates(1)"
                        >
                          Remove
                        </span>
                      </p>
                      <div class="form-row mb-4">
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              Start Time
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0 && merge_candidates[1].booking_start_time!=''
                                  ? dateFormated( merge_candidates[1].booking_start_time )
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              End Time
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0 && merge_candidates[1].booking_end_time!=''
                                  ? dateFormated( merge_candidates[1].booking_end_time )
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              Booking Number
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0
                                  ? merge_candidates[1].booking_no.toUpperCase()
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              Plate
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0
                                  ? merge_candidates[1].booking_made_license.toUpperCase()
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="col-md-6 mt-2">
                          <div class="sessionDataTxt">
                            <p
                              style="width: 80px"
                              class="sessionDataTxt__left txt--fsxs opacity--50"
                            >
                              VIN
                            </p>
                            <p class="txt--fsxs">
                              {{
                                merge_candidates.length > 0 &&
                                merge_candidates[1].booking_made_vin
                                  ? merge_candidates[1].booking_made_vin.toUpperCase()
                                  : "N/A"
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="merge_candidates.length == 2"
                    class="
                      d-flex
                      align-items-center
                      justify-content-center
                      mt-4
                    "
                  >
                    <button
                      type="button"
                      class="button button--primary button--sm mr-3"
                      @click="mergeSession"
                    >
                      Merge
                    </button>
                    <button
                      type="button"
                      class="button button--outline button--sm"
                      @click="
                        show_merge_section = false;
                        merge_candidates = [];
                        merge_session_ids = [];
                      "
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SessionDetails
     @session_delete="refreshAfterSessionDelete" 
     @audit_correct_list_refresh="refreshAuditCorrectListFromSession" 
     />
    <ShowFullScreenImage />
    <MergeSessionConfirm @merge_success="mergeSuccess"/>
  </div>
</template>

<script>
import PercentageChart from "@/components/ChartOccupancy";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import CaptureChart from "@/components/CaptureChart";
import VueTagsInput from "@johmun/vue-tags-input";
import { ModelSelect, ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import commonservices from "../../services/CommonService";
const service = new commonservices();
import SessionDetails from "@/components/modals/sessionDetails";
import ShowFullScreenImage from "@/components/modals/ShowImage";
import MergeSessionConfirm from "@/components/modals/mergeSessionConfirm";
import axios from "../../axios";

export default {
  name: "AuditPage",
  components: {
    PercentageChart,
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    CaptureChart: CaptureChart,
    VueTagsInput,
    ModelSelect,
    ModelListSelect,
    SessionDetails,
    ShowFullScreenImage,
    MergeSessionConfirm
  },
  data() {
    return {
      admin: false,
      admin_access: false,
      admin_name: "",
      admin_text: "View as User",
      view_as_user: 0,

      showTimezoneDropdown: false,
      time_zone_list: [
        'UTC',
        this.$moment.tz.guess()
      ],
      selected_time_zone: '',

      showAuditdetails: false,
      showByDropdown: false,
      date: {
        start: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
        end: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
      },

      show_property_dropdown: false,
      property_list: [],
      searchProperty: "",
      selected_property_name: "",
      selected_property_id: "",
      property_id_list: [],
      from_date: this.$moment(new Date().setHours(0, 0, 0))
        .add(-6, "days")
        .format("YYYY-MM-DD HH:mm"),
      to_date: this.$moment(new Date().setHours(0, 0, 0)).format("YYYY-MM-DD HH:mm"),
      // maxDate: this.$moment().format("YYYY-MM-DD HH:mm"),
      // to_date: '',
      maxDate: '',
      minDate: "2018-01-01",

      show_camera_dropdown: false,
      selected_camera_id: null,
      camera_filter_selected: false,

      show_plate_dropdown: false,
      plate_filter_selected: false,
      selected_plate_filter: 0,

      show_customer_dropdown: false,
      customer_filter_selected: false,
      selected_customer_filter: 0,

      show_session_dropdown: false,
      session_filter_selected: false,
      selected_session_filter: 0,

      show_manage_session_dropdown: false,
      session_managed_selected: false,
      selected_session_managed: 0,

      show_image_filter_dropdown: false,
      image_filter_selected: false,
      selected_image_filter: 0,

      search: "",

      camera_search: "",
      camera_list: [],
      camera_source: null,
      camera_page: 1,
      camera_load_more: false,

      audit_list: [],
      audit_pagination: {
        page: 1,
        load_more: true,
        infiniteId: +new Date(),
        to: 0,
        total: 0,
      },
      audit_source: null,
      selected_audit_index: null,
      audit_details: {},
      fetching_image: false,

      country_list: [],
      country_code: "US",
      country_disabled: false,
      state_list: [],
      state_disabled: false,
      state: "",
      candidate_list: [],
      license: "",
      selected_license: "",
      show_add_new_license: false,

      tag: "",
      tags: [],
      autocompleteItems: [
        {
          text: "bad lighting",
        },
        {
          text: "lighting",
        },
        {
          text: "low height",
        },
      ],
      show_correction_form: false,

      merge_candidates: [],
      merge_session_ids: [],
      show_merge_section: false,
      merge_image_fetch: false,

      report_type: "days",

      show_recognition_chart: true,
      recognition_chart_loading: false,
      recognition_capture_chart_total: 0,
      recognition_capture_chart_past_total: 0,
      recognition_capture_chart_data: [],
      recognition_capture_chart_source: null,

      show_accuracy_chart: true,
      accuracy_chart_loading: false,
      accuracy_confidence_chart_total: 0,
      accuracy_confidence_chart_past_total: 0,
      accuracu_confidence_chart_data: [],
      accuracy_confidence_chart_source: null,

      selected_audit_ids: [],
      booking_id_list:[],
      check_all_audits: false,
      sort_by: 1,
      sort_type: "DESC",
      user: {},
      audit_list_loader: true,
      audit_list_end: false,
    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        // console.log(binding);
      },
    },
  },
  computed: {
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
    percentage_recognition_capture: function () {
      if (
        this.recognition_capture_chart_total ==
        this.recognition_capture_chart_past_total
      ) {
        // this.recognition_capture_chart_inc = true;
        return "+0.00";
      } else if (
        this.recognition_capture_chart_total != 0 &&
        this.recognition_capture_chart_past_total == 0
      ) {
        // this.recognition_capture_chart_inc = true;
        return "+100.00";
      } else if (
        this.recognition_capture_chart_total == 0 &&
        this.recognition_capture_chart_past_total != 0
      ) {
        // this.recognition_capture_chart_inc = false;
        return "-100.00";
      } else if (
        this.recognition_capture_chart_total >
        this.recognition_capture_chart_past_total
      ) {
        // this.recognition_capture_chart_inc = true;
        return (
          "+" +
          (
            ((parseFloat(this.recognition_capture_chart_total) -
              parseFloat(this.recognition_capture_chart_past_total)) /
              parseFloat(this.recognition_capture_chart_past_total)) *
            100
          ).toFixed(2)
        );
      } else if (
        this.recognition_capture_chart_total <
        this.recognition_capture_chart_past_total
      ) {
        // this.recognition_capture_chart_inc = false;
        return (
          "-" +
          (
            ((parseFloat(this.recognition_capture_chart_past_total) -
              parseFloat(this.recognition_capture_chart_total)) /
              parseFloat(this.recognition_capture_chart_total)) *
            100
          ).toFixed(2)
        );
      } else {
        // this.recognition_capture_chart_inc = false;
        return "-0.00";
      }
    },
    percentage_accuracy_confidence: function () {
      if (
        this.accuracy_confidence_chart_total ==
        this.accuracy_confidence_chart_past_total
      ) {
        // this.recognition_capture_chart_inc = true;
        return "+0.00";
      } else if (
        this.accuracy_confidence_chart_total != 0 &&
        this.accuracy_confidence_chart_past_total == 0
      ) {
        // this.recognition_capture_chart_inc = true;
        return "+100.00";
      } else if (
        this.accuracy_confidence_chart_total == 0 &&
        this.accuracy_confidence_chart_past_total != 0
      ) {
        // this.recognition_capture_chart_inc = false;
        return "-100.00";
      } else if (
        this.accuracy_confidence_chart_total >
        this.accuracy_confidence_chart_past_total
      ) {
        // this.recognition_capture_chart_inc = true;
        return (
          "+" +
          (
            ((parseFloat(this.accuracy_confidence_chart_total) -
              parseFloat(this.accuracy_confidence_chart_past_total)) /
              parseFloat(this.accuracy_confidence_chart_past_total)) *
            100
          ).toFixed(2)
        );
      } else if (
        this.accuracy_confidence_chart_total <
        this.accuracy_confidence_chart_past_total
      ) {
        // this.recognition_capture_chart_inc = false;
        return (
          "-" +
          (
            ((parseFloat(this.accuracy_confidence_chart_past_total) -
              parseFloat(this.accuracy_confidence_chart_total)) /
              parseFloat(this.accuracy_confidence_chart_total)) *
            100
          ).toFixed(2)
        );
      } else {
        // this.recognition_capture_chart_inc = false;
        return "-0.00";
      }
    },
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.audit_pagination = { page: 1, page_count: 0 };
        this.getAudits();
      }
    },
    camera_search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.camera_list = [];
        this.camera_page = 1;
        this.cameraList();
      }
    },
    country_code: function (val) {
      if (val != "") {
        this.state = "";
        this.getStates();
      }
    },
    license: function (val) {
      if (val != "add" && val != "no_plate") {
        this.country_disabled = false;
        this.state_disabled = false;
        this.selected_license = this.license;
        this.show_add_new_license = false;
      } else if (val == "add") {
        this.country_disabled = false;
        this.state_disabled = false;
        this.selected_license = "";
        this.show_add_new_license = true;
      } else if (val == "no_plate") {
        this.country_disabled = true;
        this.state_disabled = true;
        this.selected_license = "no_plate";
        this.show_add_new_license = false;
      }
    },
    selected_audit_ids: function (val) {
      if (val.length == this.audit_pagination.total && val.length>0 ) {
        this.check_all_audits = true;
      }
    },
  },
  filters: {
    uppercase: function (val) {
      if (!val) return;
      if (val == "") return;

      return val.toUpperCase();
    },
  },
  beforeCreate() {
    // if (
    //   localStorage.getItem("admin_access") == undefined ||
    //   !localStorage.getItem("admin_access")
    // ) {
    //   this.$router.push("/dashboard");
    // }
  },
  created() {

    this.selected_time_zone = this.$moment.tz.guess();

    // this.setReportTimezone(this.selected_time_zone);

    this.to_date = this.$moment(new Date()).tz(this.selected_time_zone).add(-2, 'hours').format('YYYY-MM-DD HH:mm');
    this.maxDate = this.$moment(new Date()).tz(this.selected_time_zone).format('MMM D, YYYY HH:mm'); 


    if (
      localStorage.getItem("admin_access") &&
      localStorage.getItem("admin_access") == "true"
    ) {
      this.admin = true;
      this.admin_access = true;
    }
    let user_role = localStorage.getItem("role");
    let property_access_list = localStorage.getItem("commercial_access_list");
    property_access_list = JSON.parse(property_access_list);
    if (user_role == "operator") {
      if (Object.keys(property_access_list).length > 0) {
        this.property_id_list = property_access_list.property_access_list;
      }
    }

    this.cameraList();
    this.getAudits();
    this.getAllProperty();
    this.getCountries();
    this.getStates();
    this.updateCharts();

    //Decode Token
    var token = localStorage.getItem("commercial_token_new");

    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    var payload = JSON.parse(jsonPayload);
    this.admin_name =
      payload.admin_name && payload.admin_name != "" ? payload.admin_name : "";

  },
  methods: {
    setReportTimezone(time_zone) {
      // console.log(time_zone);
      if(this.selected_time_zone == time_zone) {
        return;
      }
      this.to_date = this.$moment(new Date()).tz(time_zone).add(-2, 'hours').format('YYYY-MM-DD HH:mm');

      this.selected_time_zone = time_zone;
      // this.confidenceChartData();
      // this.captureChartData();
      // this.getAudits();
    
      this.cameraList();
      this.getAudits();
      this.getAllProperty();
      this.getCountries();
      this.getStates();
      this.updateCharts();
    },
    closeTimezoneDropdown() {
      this.showTimezoneDropdown = false
    },
    openImageOnModal(audit_image) {
      this.$modal.show("show-fullscreen-image",{
        image: audit_image
      });
    },
    checkAudit(audit) {
      let audit_id = audit.id;
      let booking_id =audit.booking_id;
      if (this.selected_audit_ids.indexOf(audit_id) == -1) {
        this.selected_audit_ids.push(audit_id);
        if(audit.booking_id == "" || audit.booking_id==null){
          return false;
        }
        else{
          if(this.booking_id_list.indexOf(booking_id) == -1){
            this.booking_id_list.push(booking_id);
          }
          else{
            return false;
          }
        }

      } else {
        let index = this.selected_audit_ids.indexOf(audit_id);
        let booking_index =this.booking_id_list.indexOf(booking_id);
        this.$delete(this.selected_audit_ids, index);
        this.$delete(this.booking_id_list,booking_index);
        this.check_all_audits = false;
      }
      // console.log(this.booking_id_list);
      // console.log(this.selected_audit_ids);
    },
    // checkSession(audit){
    //   let booking_id =audit.booking_id;
    //   let audit_id = audit.id;

    //   console.log(this.booking_id_list.indexOf(booking_id));
    //   if(this.booking_id_list.indexOf(booking_id) == -1){
    //     this.booking_id_list.push(booking_id);
    //   }
    //   else{
    //     let index =this.booking_id_list.indexOf(booking_id);
    //     this.$delete(this.booking_id_list,index);
    //   }
    //   console.log(this.booking_id_list);
    // },
    reset() {
      this.item = {};
    },
    selectFromParentComponent1() {
      // select option from parent component
      this.item = this.options[0];
    },
    reset2() {
      this.item2 = "";
    },
    selectFromParentComponent2() {
      // select option from parent component
      this.item2 = this.options2[0].value;
    },
    showDropDown(value) {
      switch (value) {
        case 1:
          this.show_property_dropdown = true;
          this.show_camera_dropdown = false;
          this.show_session_dropdown = false;
          this.show_plate_dropdown = false;
          this.show_customer_dropdown = false;
          this.show_manage_session_dropdown = false;
          this.show_image_filter_dropdown = false;
          break;
        case 2:
          this.show_property_dropdown = false;
          this.show_camera_dropdown = true;
          this.show_session_dropdown = false;
          this.show_plate_dropdown = false;
          this.show_customer_dropdown = false;
          this.show_manage_session_dropdown = false;
          this.show_image_filter_dropdown = false;
          break;
        case 3:
          this.show_property_dropdown = false;
          this.show_camera_dropdown = false;
          this.show_session_dropdown = false;
          this.show_plate_dropdown = true;
          this.show_customer_dropdown = false;
          this.show_manage_session_dropdown = false;
          this.show_image_filter_dropdown = false;
          break;
        case 4:
          this.show_property_dropdown = false;
          this.show_camera_dropdown = false;
          this.show_session_dropdown = false;
          this.show_plate_dropdown = false;
          this.show_customer_dropdown = true;
          this.show_manage_session_dropdown = false;
          this.show_image_filter_dropdown = false;
          break;
        case 5:
          this.show_property_dropdown = false;
          this.show_camera_dropdown = false;
          this.show_session_dropdown = true;
          this.show_plate_dropdown = false;
          this.show_customer_dropdown = false;
          this.show_manage_session_dropdown = false;
          this.show_image_filter_dropdown = false;
          break;
        case 6:
          this.show_property_dropdown = false;
          this.show_camera_dropdown = false;
          this.show_session_dropdown = false;
          this.show_plate_dropdown = false;
          this.show_customer_dropdown = false;
          this.show_manage_session_dropdown = true;
          this.show_image_filter_dropdown = false;
          break;
        case 7:
          this.show_property_dropdown = false;
          this.show_camera_dropdown = false;
          this.show_session_dropdown = false;
          this.show_plate_dropdown = false;
          this.show_customer_dropdown = false;
          this.show_manage_session_dropdown = false;
          this.show_image_filter_dropdown = true;
          break;
        default:
          this.closeDropdown();
          break;
      }
    },
    preventClose(e) {
      if (
        e.target.id == "clear_filter_camera" ||
        e.target.id == "clear_filter_property" ||
        e.target.classList.contains("camera_item") ||
        e.target.classList.contains("property_item")
      ) {
        return;
      }
      e.stopPropagation();
    },
    closeDropdown() {
      this.show_property_dropdown = false;
      this.show_camera_dropdown = false;
      this.show_session_dropdown = false;
      this.show_plate_dropdown = false;
      this.show_customer_dropdown = false;
      this.show_manage_session_dropdown = false;
      this.show_image_filter_dropdown = false;
    },

    //=========//
    getCountries() {
      this.axios
        .post(window.hostname + "/api/auth/get-countries")
        .then((res) => {
          if (res.data.status) {
            this.country_list = res.data.data.country_list;
          } else {
            this.country_list = [];
          }
        })
        .catch((err) => {
          this.country_list = [];
        });
    },
    getStates() {
      this.axios
        .post(window.hostname + "/api/auth/get-states", {
          country_code: this.country_code,
        })
        .then((res) => {
          if (res.data.status) {
            this.state_list = res.data.data.state_list;
          } else {
            this.state_list = [];
          }
        })
        .catch((err) => {
          this.state_list = [];
        });
    },
    cameraList() {
      if (this.camera_source) {
        this.camera_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.camera_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/camera-list",
          {
            search: this.camera_search,
            property_id: this.selected_property_id,
            page: this.camera_page,
          },
          {
            cancelToken: this.camera_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            this.camera_list = res.data.data.camera_list;
            if (res.data.data.pagination.load_more) {
              this.camera_load_more = true;
              this.camera_page++;
            } else {
              this.camera_load_more = false;
            }
          } else {
            this.camera_load_more = false;
            this.camera_list = [];
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err.message);
          } else {
            this.camera_load_more = false;
            this.camera_list = [];
          }
        });
    },
    camera_paginate($state) {
      if (this.camera_source) {
        this.camera_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.camera_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/camera-list",
          {
            search: this.camera_search,
            property_id: this.selected_property_id,
            page: this.camera_page,
          },
          {
            cancelToken: this.camera_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            let camera_list = res.data.data.camera_list;
            camera_list.map((val) => {
              this.camera_list.push(val);
            });
            if (res.data.data.pagination.load_more) {
              $state.loaded();
              this.camera_load_more = true;
              this.camera_page++;
            } else {
              $state.complete();
              this.camera_load_more = false;
            }
          } else {
            $state.complete();
            this.camera_load_more = false;
            this.camera_list = [];
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err.message);
          } else {
            $state.complete();
            this.camera_load_more = false;
            this.camera_list = [];
          }
        });
    },
    async getAllProperty() {
      let property_response = await service.getAllProperty(this.searchProperty);
      if (property_response.status == 200) {
        if (property_response.data.status) {
          this.property_list = property_response.data.data.all_space;
        } else {
          this.property_list = [];
        }
      } else {
        this.$toasted.show("Something went wrong. Please try again!", {
          icon: "timex-circle",
          className: "error-class",
        });
      }
    },
    clearPropertyFilter() {
      this.searchProperty = "";
      this.selected_property_name = "";
      this.selected_property_id = "";
      this.audit_pagination.page = 1;
      this.audit_list = [];
      this.audit_details = {};
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.show_correction_form = false;
      this.camera_list = [];
      this.camera_page = 1;
      this.selected_camera_id = null;
      this.camera_search = "";
      this.cameraList();
      this.getAudits();
      this.updateCharts();
    },
    getAudits() {
      if (this.audit_source) {
        this.audit_source.cancel("Cancel previous request");
      }
      this.audit_list_loader = true;
      const CancelToken = this.axios.CancelToken;
      this.audit_source = CancelToken.source();
      this.axios
        .post(
          window.hostname + "/api/auth/audit-list",
          {
            search: this.search,
            // time_zone: this.$moment.tz.guess(),
            time_zone: this.selected_time_zone,
            page: this.audit_pagination.page,
            property_id: this.selected_property_id,
            property_id_list: this.property_id_list,
            from_date: this.from_date,
            to_date: this.to_date,
            plate_filter: this.selected_plate_filter,
            booking_type: this.selected_customer_filter,
            session_filter: this.selected_session_filter,
            session_managed: this.selected_session_managed,
            file_filter: this.selected_image_filter,
            camera_filter: this.selected_camera_id,
            view_as_user: this.view_as_user,
            sort_by: this.sort_by,
            sort_type: this.sort_type,
          },
          {
            cancelToken: this.audit_source.token,
          }
        )
        .then((res) => {
          this.audit_list_loader = false;
          if (res.data.status) {
            this.audit_list = res.data.data.audit_data;
            this.audit_pagination.page = res.data.data.pagination.page;
            this.audit_pagination.load_more =
              res.data.data.pagination.load_more == 1 ? true : false;
            this.audit_pagination.to = res.data.data.pagination.to;
            this.audit_pagination.total = res.data.data.pagination.total;
          } else {
            this.audit_pagination.page = 1;
            this.audit_pagination.load_more = false;
            this.audit_pagination.total = 0;
            this.audit_pagination.to = 0;
            this.audit_list = [];
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            this.audit_list_loader = false;
            // console.log("Request canceled", err.message);
          } else {
            this.$router.push("/dashboard");
          }
        });
    },
    dateFormated(date) {
      if (!date) return;

      var formatted = this.$moment(date).format("MMM D,YYYY hh:mm:ss:SSS A");
      return formatted;
    },
    auditDetails(index) {
      //console.log("index-auditDetails >>>>>>>>>>"+index);
      if (this.selected_audit_index != index) {
        this.selected_audit_index = index;
        //console.log("this.selected_audit_index >>>>>>>>>>"+this.selected_audit_index);
        this.tags = [];
        this.state = "";
        this.country_code = "US";
        this.license = "";
        this.selected_license = "";
        this.showAuditdetails = true;
        this.show_correction_form = false;
        this.show_merge_section = false;
        this.audit_details = this.audit_list[index];

        if (!this.admin && this.audit_details.correct_license == "NO PLATE") {
          this.audit_details.recognition_data = [];
        }

        if (this.audit_details.recognition_data.length > 0) {
          let data = this.audit_details.recognition_data[0];
          this.country_code = data.region.code
            ? data.region.code.split("-")[0].toUpperCase()
            : "";
          this.state =
            data.region.code && data.region.code.split("-")[1]
              ? data.region.code.split("-")[1].toUpperCase()
              : "";
          this.candidate_list = [];
          data.candidates.map((val) => {
            this.candidate_list.push({
              value: val.plate.toUpperCase(),
              text: val.plate,
            });
          });
          this.candidate_list.push({
            value: "add",
            text: "Add New",
          });
          if (
            this.audit_details.booking_id == undefined ||
            this.audit_details.booking_id == null ||
            this.audit_details.booking_id == ""
          ) {
            this.candidate_list.push({
              value: "no_plate",
              text: "No Plate",
            });
          }

          // this.audit_details.correction_details =
          //   this.audit_details.correction_details;
        } else {
          this.candidate_list = [];
          this.candidate_list.push({
            value: "add",
            text: "Add New",
          });
          this.candidate_list.push({
            value: "no_plate",
            text: "No Plate",
          });
        }
        this.fetching_image = true;

        fetch(window.awsURLNew + this.audit_details.file)
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.audit_details.image = data.body.URL;
            this.fetching_image = false;
          })
          .catch((err) => {
            // console.log(err);
            this.audit_details.image = "";
            this.fetching_image = false;
          });
      } else {
        this.selected_audit_index = null;
        this.showAuditdetails = false;
        this.show_merge_section = false;
        this.show_correction_form = false;
        this.audit_details = {};
        this.fetching_image = false;
      }
    },
    paginate($state) {
      if (this.audit_source) {
        this.audit_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.audit_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/audit-list",
          {
            search: this.search,
            time_zone: this.$moment.tz.guess(),
            page: this.audit_pagination.page,
            property_id: this.selected_property_id,
            property_id_list: this.property_id_list,
            from_date: this.from_date,
            to_date: this.to_date,
            plate_filter: this.selected_plate_filter,
            booking_type: this.selected_customer_filter,
            session_filter: this.selected_session_filter,
            session_managed: this.selected_session_managed,
            file_filter: this.selected_image_filter,
            camera_filter: this.selected_camera_id,
            view_as_user: this.view_as_user,
            sort_by: this.sort_by,
            sort_type: this.sort_type,
          },
          {
            cancelToken: this.audit_source.token,
          }
        )

        .then((res) => {
          console.log(res.data.data.audit_data.length);
          console.log(this.audit_list_end);
          if(res.data.data.audit_data.length < 20)
          {
            this.audit_list_end = true;
          }
          console.log(this.audit_list_end);

          if (res.data.status) {

            let audit_list = res.data.data.audit_data;
            audit_list.map((val) => {
              this.audit_list.push(val);

              if (this.check_all_audits) {
                this.selected_audit_ids.push(val.id);
              }
            });
          } else {
            this.audit_list = [];
          }

          this.audit_pagination.page = res.data.data.pagination.page;
          this.audit_pagination.load_more =
            res.data.data.pagination.load_more == 1 ? true : false;
          this.audit_pagination.to = res.data.data.pagination.to;
          this.audit_pagination.total = res.data.data.pagination.total;

          if (!this.audit_pagination.load_more) {
            $state.loaded();
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch((err) => {
          $state.complete();
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err.message);
          } else {
            this.$router.push("/dashboard");
          }
        });
    },
    getAuditsForProperty(property) {
      this.selected_property_name =
        property.property_name != ""
          ? property.property_name
          : property.address.split(",")[0];
      this.selected_property_id = property.space_id;
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.audit_details = {};
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.camera_list = [];
      this.camera_page = 1;
      this.camera_search = "";
      this.selected_camera_id = null;
      this.cameraList();
      this.getAudits();
      this.updateCharts();
    },
    getAuditsForDate() {
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.audit_details = {};
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.getAudits();
      this.updateCharts();
    },
    getPreviousDateRange() {
      if (this.from_date == null || this.to_date == null) {
        this.$toasted.show("Please select a proper date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      let start = this.$moment(this.from_date).format("YYYY-MM-DD HH:mm");
      let end = this.$moment(this.to_date).format("YYYY-MM-DD HH:mm");

      var timeDiff = Math.abs(
        new Date(end).getTime() - new Date(start).getTime()
      );
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      //Check If From Date Does Not Goes Past The Min Date
      if (
        this.$moment(this.from_date)
          .add(-diffDays, "days")
          .format("YYYY-MM-DD") <=
        this.$moment(this.minDate).format("YYYY-MM-DD")
      ) {
        return false;
      }
      this.to_date = this.$moment(this.from_date)
        .add(-1, "days")
        .format("YYYY-MM-DD HH:mm");
      this.from_date = this.$moment(this.from_date)
        .add(-diffDays, "days")
        .format("YYYY-MM-DD HH:mm");
      this.getAuditsForDate();
    },
    getNextDateRange() {
      if (this.from_date == null || this.to_date == null) {
        this.$toasted.show("Please select a proper date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return false;
      }

      let start = this.$moment(this.from_date).format("YYYY-MM-DD HH:mm");
      let end = this.$moment(this.to_date).format("YYYY-MM-DD HH:mm");

      var timeDiff = Math.abs(
        new Date(end).getTime() - new Date(start).getTime()
      );
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (
        this.$moment(this.from_date)
          .add(diffDays + 1, "days")
          .format("YYYY-MM-DD") >= this.$moment().format("YYYY-MM-DD")
      ) {
        return false;
      }
      this.from_date = this.$moment(this.to_date)
        .add(1, "days")
        .format("YYYY-MM-DD HH:mm");
      this.to_date = this.$moment(this.from_date)
        .add(diffDays, "days")
        .format("YYYY-MM-DD HH:mm");

      this.getAuditsForDate();
    },
    filterByPlate(type) {
      this.selected_plate_filter = type;
      if (this.selected_plate_filter > 0) {
        this.plate_filter_selected = true;
      } else {
        this.plate_filter_selected = false;
      }
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_list = [];
      this.audit_details = {};
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.getAudits();

      this.$nextTick(() => {
        this.closeDropdown();
      });
    },
    filterByCustomer(type) {
      this.selected_customer_filter = type;
      if (this.selected_customer_filter > 0) {
        this.customer_filter_selected = true;
      } else {
        this.customer_filter_selected = false;
      }
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.audit_details = {};
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.getAudits();
    },
    filterBySessions(type) {
      this.selected_session_filter = type;
      if (this.selected_session_filter > 0) {
        this.session_filter_selected = true;
      } else {
        this.session_filter_selected = false;
      }
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.audit_details = {};
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.getAudits();
    },
    filterByManagedSessions(type) {
      this.selected_session_managed = type;
      if (this.selected_session_managed > 0) {
        this.session_managed_selected = true;
      } else {
        this.session_managed_selected = false;
      }
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.audit_details = {};
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.getAudits();
    },
    filterByImage(type) {
      this.selected_image_filter = type;
      if (this.selected_image_filter > 0) {
        this.image_filter_selected = true;
      } else {
        this.image_filter_selected = false;
      }
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.audit_details = {};
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.getAudits();
    },
    selectCameraId(camera) {
      this.selected_camera_id = camera.camera_id;
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.camera_filter_selected = true;
      this.getAudits();
    },
    clearFilter() {
      this.selected_camera_id = "";
      this.camea_search = "";
      this.camera_list = [];
      this.camera_page = 1;
      this.camera_filter_selected = false;
      this.cameraList();
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.getAudits();
    },
    showCorrectionForm() {
      this.show_correction_form = !this.show_correction_form;
    },
    markAsCorrect() {
      const self = this;
      this.$swal({
        title: "",
        html: `<p class="txt--ss font-weight-bold txt--off-white" >Are you sure you want to mark this audit as correct?</p>`,

        showCancelButton: true,
      }).then((result) => {
        if (result.isDismissed) {
          return false;
        }

        self.axios
          .post(window.hostname + "/api/auth/mark-audit", {
            audit_id: self.audit_details.id,
            correction_needed: 0,
          })
          .then((res) => {
            if (res.data.status) {
              self.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
              });
              // this.showAuditdetails = false;
              self.show_merge_section = false;
              // this.audit_pagination = { page: 1, page_count: 0 };
              // this.audit_list = [];
              // this.getAudits();
              if (self.audit_details.correction_details.length > 0) {
                self.audit_details.correction_details.push({    //unshift
                  admin: self.admin_name,
                  mark_as_correct: 1,
                  region_code: "",
                  license: "",
                  correction_at: this.$moment().format("LLLL"),
                  tags: [],
                });
              } else {
                self.audit_details.correction_details = [
                  {
                    admin: self.admin_name,
                    mark_as_correct: 1,
                    region_code: "",
                    license: "",
                    correction_at: this.$moment().format("LLLL"),
                    tags: [],
                  },
                ];
              }

              self.audit_details.correct_license = JSON.parse(
                JSON.stringify(self.audit_details.license)
              );

              self.audit_details.correct = 1;
              self.audit_details.correction_needed = 0;
            } else {
              self.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      });
    },
    updateAudit() {
      var region_code =
        this.country_code == this.state ||
        (this.country_code != "" && this.state == "")
          ? this.country_code
          : this.country_code + "-" + this.state;
      var tag_inputs = this.tags
        .filter((val) => val.text)
        .map(({ text }) => text);
      if (this.selected_license.length > 12) {
        this.$toasted.show(
          "License plate can not have more than 12 characters long!",
          {
            icon: "times-circle",
            className: "error-class",
          }
        );
        return;
      }

      this.axios
        .post(window.hostname + "/api/auth/mark-audit", {
          audit_id: this.audit_details.id,
          correction_needed: 1,
          country_code: this.country_code,
          state: this.state,
          license_id: this.selected_license,
          region_code: region_code,
          tags: tag_inputs,
        })
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            // this.showAuditdetails = false;
            this.show_merge_section = false;
            this.show_correction_form = false;
            // this.audit_pagination = { page: 1, page_count: 0 };
            // this.audit_list = [];
            // this.getAudits();
            if (this.audit_details.correction_details.length > 0) {
              this.audit_details.correction_details.push({  //unshift
                admin: this.admin_name,
                mark_as_correct: 0,
                region_code: region_code,
                license: this.selected_license,
                correction_at: this.$moment().format("LLLL"),
                tags: tag_inputs,
              });
            } else {
              this.audit_details.correction_details = [
                {
                  admin: this.admin_name,
                  mark_as_correct: 0,
                  region_code: region_code,
                  license: this.selected_license,
                  correction_at: this.$moment().format("LLLL"),
                  tags: tag_inputs,
                },
              ];
            }

            this.audit_details.correct_license = this.selected_license;

            this.audit_details.correct = 1;
            this.audit_details.correction_needed = 1;
          } else {
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    openSessionDetails(session_id, start_time_less_booking, booking_cancelled) {
      if (session_id == "" || session_id == undefined || session_id == null) {
        return;
      }
      var url = window.hostname;
      let formData = {
        booking_id: session_id,
        mode: "show-booking",
        time_zone: this.$moment.tz.guess(new Date()),
        booking_for: "owner",
      };

      if (start_time_less_booking == 1) {
        url += "/api/auth/start_less_booking";
      } else if (booking_cancelled == 1) {
        url += "/api/auth/booking";

        formData.cancelled_sessions = 1;
      } else {
        url += "/api/auth/booking";
      }
      this.axios
        .post(url, formData)
        .then((res) => {
          if (res.data.status) {
            this.$modal.show("session-details", {
              data: res.data.data.booking_details,
              session_type:
                res.data.data.booking_details.booking_end_date != "" ? 2 : 1,
            });
          } else {
            return;
          }
        })
        .catch((err) => {
          return;
        });
    },
    getCandidatesForMerge() {
      if(this.merge_candidates.length < 2) {
        this.show_merge_section = true;

        this.merge_candidates.push(JSON.parse(JSON.stringify(this.audit_details)));
        this.merge_session_ids.push(JSON.parse(JSON.stringify(this.audit_details.booking_id)));
      }
      else {
        return;
      }
    },
    getCandidatesForMergeOld() {
      //========== Check Candidates =============//
      if (this.merge_candidates.length == 0) {
        if (this.audit_details.booking_type == "anonymous") {
          this.show_merge_section = true;
          this.merge_candidates.push(
            JSON.parse(JSON.stringify(this.audit_details))
          );
          this.merge_session_ids.push(
            JSON.parse(JSON.stringify(this.audit_details.booking_id))
          );
        } else {
          this.$toasted.show("Please select an anonymous session!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
        }
      } else if (this.merge_candidates.length == 1) {
        if (this.audit_details.booking_type == "anonymous") {
          //=========== Check The Merge Candidate At Position 0 ================//
          if (
            this.merge_candidates[0].start_time_less_booking == 1 &&
            this.audit_details.start_time_less_booking == 1
          ) {
            this.$toasted.show(
              "You have already selected a start time less session. Please select an anonymous session!",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
            return;
          }
          if (
            this.merge_candidates[0].start_time_less_booking == 0 &&
            this.audit_details.start_time_less_booking == 0
          ) {
            this.$toasted.show(
              "You have already selected an anonymous session. Please select a start time less session!",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
            return;
          }
          //================ Check Time ===============================//
          if (this.merge_candidates[0].start_time_less_booking == 1) {
            //======== If First Candidate Selected Was Start Time Less Session ========//
            let date1 = this.$moment(
              this.merge_candidates[0].booking_end_time
            ).format("YYYY-MM-DD HH:mm:ss");
            let date2 = this.$moment(
              this.audit_details.booking_start_time
            ).format("YYYY-MM-DD HH:mm:ss");

            //========== date1 should be larger than date2 =============//
            if (this.$moment(date1).diff(date2) > 0) {
              this.show_merge_section = true;
              this.merge_candidates.push(
                JSON.parse(JSON.stringify(this.audit_details))
              );
              this.merge_session_ids.push(
                JSON.parse(JSON.stringify(this.audit_details.booking_id))
              );
            } else {
              this.$toasted.show(
                "Please select an anonymous session with start time less than the end time of the previously selected start time less session!",
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
              return;
            }
          } else {
            //======== If First Candidate Selected Was anonymous Session ========//
            let date1 = this.$moment(
              this.merge_candidates[0].booking_start_time
            ).format("YYYY-MM-DD HH:mm:ss");
            let date2 = this.$moment(
              this.audit_details.booking_end_time
            ).format("YYYY-MM-DD HH:mm:ss");
            this.merge_session_ids.push(
              JSON.parse(JSON.stringify(this.audit_details.booking_id))
            );
            //========== date1 should be larger than date2 =============//
            if (this.$moment(date2).diff(date1) > 0) {
              this.show_merge_section = true;
              this.merge_candidates.push(
                JSON.parse(JSON.stringify(this.audit_details))
              );
            } else {
              this.$toasted.show(
                "Please select a start time less session with an end date greater than that the start time of the previously selected anonymous session!",
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
              return;
            }
          }
        } else {
          this.$toasted.show("Please select an anonymous session!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
        }
      } else if (this.merge_candidates.length == 2) {
        this.$toasted.show("You have already selected two sessions!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
    },
    mergeSession() {
      // const self = this;
      this.$modal.show("merge-session-confirm",{
        merge_candidates: this.merge_candidates
      });

      // let vehicle1 = this.merge_candidates[0].booking_made_license;
      // let vehicle2 = this.merge_candidates[1].booking_made_license;
      // let start_less_booking_id = "";
      // let anonymous_booking_id = "";
      // if (this.merge_candidates[0].start_time_less_booking == 1) {
      //   start_less_booking_id = this.merge_candidates[0].booking_id;
      //   anonymous_booking_id = this.merge_candidates[1].booking_id;
      // } else {
      //   start_less_booking_id = this.merge_candidates[1].booking_id;
      //   anonymous_booking_id = this.merge_candidates[0].booking_id;
      // }

      // this.$swal({
      //   title: "",
      //   html: `<p class="txt--ss font-weight-bold txt--off-white" >Choose Vehicle</p>`,
      //   confirmButtonText: `<p class="d-flex justify-content-center">${vehicle1}</p>`,
      //   cancelButtonText: `<p class="d-flex justify-content-center">${vehicle2}</p>`,
      //   showDenyButton: true,
      //   denyButtonText: "Delete",
      //   showCancelButton: true,
      // }).then((result) => {
      //   let license_id = "";
      //   if (result.isConfirmed) {
      //     license_id = vehicle1;
      //   } else if (result.isDismissed && result.dismiss == "cancel") {
      //     license_id = vehicle2;
      //   } else {
      //     return true;
      //   }
      //   if (license_id != "") {
      //     self.axios
      //       .post(window.hostname + "/api/auth/merge-audit", {
      //         license_id: license_id,
      //         start_time_less_booking_id: start_less_booking_id,
      //         anonymous_booking_id: anonymous_booking_id,
      //       })
      //       .then((res) => {
      //         if (res.data.status) {
      //           this.showAuditdetails = false;
      //           this.show_merge_section = false;
      //           this.audit_pagination = { page: 1, page_count: 0 };
      //           this.audit_list = [];
      //           this.getAudits();
      //         }
      //       });
      //   }
      // });
    },
    mergeSuccess() {
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.merge_candidates = [];
      this.merge_session_ids = [];
      this.audit_pagination = { page: 1, page_count: 0 };
      this.audit_list = [];
      this.getAudits();
    },
    removeCandidates(index) {
      let session_index = this.merge_session_ids.indexOf(
        this.merge_candidates[index].booking_id
      );
      this.$delete(this.merge_session_ids, session_index);
      this.$delete(this.merge_candidates, index);

      if (this.merge_candidates.length == 0) {
        this.showAuditdetails = true;
        this.show_merge_section = false;
      }
    },
    noPlateCorrection() {
      const self = this;
      this.$swal({
        title: "",
        html: `<p class="txt--ss font-weight-bold txt--off-white" >Are you sure you want to mark this recognition with no plate?</p>`,

        showCancelButton: true,
      }).then((result) => {
        if (result.isDismissed) {
          return false;
        }

        self.axios
          .post(window.hostname + "/api/auth/mark-audit", {
            audit_id: self.audit_details.id,
            correction_needed: 1,
            country_code: "",
            state: "",
            license_id: "no_plate",
            region_code: "",
            tags: [],
          })
          .then((res) => {
            if (res.data.status) {
              self.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
              });
              // self.showAuditdetails = false;
              self.show_merge_section = false;
              self.show_correction_form = false;
              // self.audit_pagination = { page: 1, page_count: 0 };
              // self.audit_list = [];
              // self.getAudits();

              if (self.audit_details.correction_details.length > 0) {
                self.audit_details.correction_details.push({  //unshift
                  admin: self.admin_name,
                  mark_as_correct: 0,
                  region_code: "",
                  license: "NO PLATE",
                  correction_at: this.$moment().format("LLLL"),
                  tags: [],
                });
              } else {
                self.audit_details.correction_details = [
                  {
                    admin: self.admin_name,
                    mark_as_correct: 0,
                    region_code: "",
                    license: "NO PLATE",
                    correction_at: this.$moment().format("LLLL"),
                    tags: [],
                  },
                ];
              }

              self.audit_details.correct_license = "NO PLATE";

              self.audit_details.correct = 1;
              self.audit_details.correction_needed = 1;
            } else {
              self.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      });
    },
    cancelSession() {
      const self = this;
      this.$swal({
        title: "",
        html: `<p class="txt--ss font-weight-bold txt--off-white" >Are you sure you want to cancel the session associated with this audit?</p>`,

        showCancelButton: true,
      }).then((result) => {
        if (result.isDismissed) {
          return false;
        }

        self.axios
          .post(window.hostname + "/api/auth/cancel-session", {
            booking_id: self.audit_details.booking_id,
          })
          .then((res) => {
            if (res.data.status) {
              self.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
              });

              self.show_merge_section = false;
              self.show_correction_form = false;

              self.audit_details.booking_cancelled = 1;
            } else {
              self.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      });
    },
    changeUser() {
      this.admin = !this.admin;
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.showAuditdetails = false;
      this.show_merge_section = false;
      this.audit_details = {};
      this.show_correction_form = false;
      this.selected_session_managed = 0;
      this.selected_image_filter = 0;
      if (this.admin) {
        this.view_as_user = 0;
        this.show_recognition_chart = false;
        this.show_accuracy_chart = false;
        this.admin_text = "View as User";
      } else {
        this.view_as_user = 1;
        this.show_recognition_chart = true;
        this.show_accuracy_chart = true;
        this.admin_text = "View as Admin";
      }

      this.getAudits();

      this.updateCharts();
    },
    async markAuditBulk() {
      const { value: selected_data } = await this.$swal({
        title: "Mark Audits",
        html: `<div> 
                <p>Mark As </p>
                <div class="row justify-content-center">
                  <div class="col-sm-6 mt-2">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="correct" class="custom-control-input" name="mark_as" value="correct"><label for="correct" class="custom-control-label">Correct</label>
                    </div>
                  </div>
                  <div class="col-sm-6 mt-2">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="no_plate" class="custom-control-input" name="mark_as" value="no_plate"><label for="no_plate" class="custom-control-label">No Plate</label>
                    </div>
                  </div>
                </div>`,
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          if (document.querySelector('input[name="mark_as"]:checked')) {
            let selected_value = document.querySelector(
              'input[name="mark_as"]:checked'
            ).value;

            if (selected_value) {
              return selected_value;
            } else {
              this.$toasted.show("Please select one of the options listed!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            }
          } else {
            this.$toasted.show("Please select one of the options listed!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          }
        },
      });

      if (selected_data !== undefined) {
        // console.log(selected_data, this.selected_audit_ids);

        this.axios
          .post(window.hostname + "/api/auth/mark-audit-bulk", {
            audit_list: this.selected_audit_ids,
            correction_type: selected_data == "correct" ? 1 : 0,

            search: this.search,
            time_zone: this.$moment.tz.guess(),
            property_id: this.selected_property_id,
            from_date: this.from_date,
            to_date: this.to_date,
            plate_filter: this.selected_plate_filter,
            booking_type: this.selected_customer_filter,
            session_filter: this.selected_session_filter,
            session_managed: this.selected_session_managed,
            file_filter: this.selected_image_filter,
            camera_filter: this.selected_camera_id,
            select_all: this.check_all_audits ? 1 : 0,
          })
          .then((res) => {
            if (res.data.status) {
              this.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
              });
              this.refreshAfterBulkAudit(selected_data == "correct" ? 1 : 0);
              // this.audit_list = [];
              // this.audit_pagination.page = 1;
              // this.getAudits();
            } else {
              this.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    refresh() {
      this.audit_pagination.page = 1;
      this.audit_pagination.load_more = false;
      this.audit_pagination.total = 0;
      this.audit_pagination.to = 0;
      this.audit_pagination.page_count = 0;
      this.audit_list = [];
      this.booking_id_list=[];
      this.selected_audit_ids=[];
      this.getAudits();
    },
    refreshAfterSessionDelete(event){
      
      // console.log("event>>>>>"+event);
      if(event!='bulk'){
       /*  var index = this.audit_list.map(function(o) { return o.booking_id; }).indexOf(event.session_id);
        if(index>-1){
          //this.$delete(this.audit_list, index);
          this.audit_list[index].booking_no = '';
          this.audit_list[index].booking_id = '';
          this.audit_list[index].booking_type = '';     

        } */

        this.audit_list.map((item,index) => { 
                if (item.booking_id === event.session_id) {
                  this.audit_list[index].booking_no = '';
                  this.audit_list[index].booking_id = '';
                  this.audit_list[index].booking_type = '';  
                } else {
                    return item;    
                }
          });
      }
      else{
        /* this.booking_id_list.forEach(session_id => {
                let index1 = this.audit_list.map(function(o) { return o.booking_id; }).indexOf(session_id);
                if(index1>-1){
                 // this.$delete(this.audit_list, index1);
                 this.audit_list[index1].booking_no = '';
                 this.audit_list[index1].booking_id = '';
                 this.audit_list[index1].booking_type = ''; 
                }
        }); */

        this.booking_id_list.forEach(session_id => {
            this.audit_list.map((item,index) => { 
                  if (item.booking_id === session_id) {
                    this.audit_list[index].booking_no = '';
                    this.audit_list[index].booking_id = '';
                    this.audit_list[index].booking_type = '';  
                  } else {
                      return item;    
                  }
            });
        });
        
      }
      this.booking_id_list=[];
      this.selected_audit_ids=[];
      //this.getAudits();
    },
    refreshAuditCorrectListFromSession(event){
      
      this.audit_list.forEach((val,index) => {
         
          if (this.audit_list[index].booking_id == event.session_id){

           // console.log("license_id>>>>>>>>>>"+event.correct_vehicle_details.license_id);
            //let correct_vehicle_details = JSON.stringify(event.correct_vehicle_details);
            //console.log("json string>>>"+correct_vehicle_details);

            this.audit_list[index].correct_license = event.correct_vehicle_details.license_id;
            this.audit_list[index].correct = 1;
            this.audit_list[index].correction_needed = 1;
            
            this.audit_list[index].correction_details.push({
                  admin: this.admin_name,
                  mark_as_correct: 0,
                  region_code: event.correct_vehicle_details.region_code,
                  license: event.correct_vehicle_details.license_id,
                  correction_at: this.$moment().format("LLLL"),
                  tags: [],
            });   
          }                
              
      });   
      
      if(this.selected_audit_index!=null){
        let selected_audit_index_temp = this.selected_audit_index;
        this.selected_audit_index = null;
        //console.log("selected_audit_index_temp>>>>"+selected_audit_index_temp);
        this.auditDetails(selected_audit_index_temp);
      }
    
    },
    refreshAfterBulkAudit(correct_type){
      
      this.selected_audit_ids.forEach(audit_id => {
              let index1 = this.audit_list.map(function(o) { return o.id; }).indexOf(audit_id);
              if(index1>-1){
                this.audit_list[index1].correct=1;   
                if(correct_type==1){           
                  this.audit_list[index1].correction_needed=0;
                  this.audit_list[index1].correct_license =  this.audit_list[index1].license;
                }
                else{
                  this.audit_list[index1].correction_needed=1;
                  this.audit_list[index1].correct_license = 'NO PLATE';
                }
                //this.$set(this.audit_list, index1);
              }
      });
      //this.booking_id_list=[];
      //this.selected_audit_ids=[];
      //this.getAudits();
    },
    //==========//
    showChart(type) {
      this.chartDateType();

      if (type == "capture") {
        this.show_recognition_chart = false;
        this.captureChartData();
      } else if (type == "recognition") {
        this.show_recognition_chart = true;
        this.recognitionChartData();
      } else if (type == "confidence") {
        this.show_accuracy_chart = false;
        this.confidenceChartData();
      } else if (type == "accuracy") {
        this.show_accuracy_chart = true;
        this.accuracyChartData();
      } else {
        this.$toasted.show("Type not recognized!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
    },
    updateCharts() {
      this.chartDateType();
      if (this.show_recognition_chart) {
        this.recognitionChartData();
      } else {
        this.captureChartData();
      }

      if (this.show_accuracy_chart) {
        this.accuracyChartData();
      } else {
        this.confidenceChartData();
      }
    },
    chartDateType() {
      if (this.from_date == null || this.to_date == null) {
        this.$toasted.show("Please select a proper date range!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      // Date Range And Range Type Checker
      let start = this.$moment(this.from_date).format("YYYY-MM-DD HH:mm");
      let end = this.$moment(this.to_date).format("YYYY-MM-DD HH:mm");

      var timeDiff = Math.abs(
        new Date(end).getTime() - new Date(start).getTime()
      );
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (diffDays == 1) {
        this.report_type = "day";
      } else if (diffDays > 1 && diffDays <= 31) {
        this.report_type = "days";
      } else if (diffDays > 31 && diffDays <= 366) {
        this.report_type = "months";
      } else if (diffDays > 365) {
        this.report_type = "years";
      }
    },
    captureChartData() {
      this.recognition_chart_loading = true;
      this.recognition_capture_chart_total = 0;
      this.recognition_capture_chart_past_total = 0;
      this.recognition_capture_chart_data = [];

      if (this.recognition_capture_chart_source) {
        this.recognition_capture_chart_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.recognition_capture_chart_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/capture-report",
          {
            from_date: this.$moment(this.from_date).format("YYYY-MM-DD HH:mm"),
            to_date: this.$moment(this.to_date).format("YYYY-MM-DD HH:mm"),
            time_zone: this.$moment.tz.guess(),
            type: this.report_type,
            property_id: this.selected_property_id,
          },
          {
            cancelToken: this.recognition_capture_chart_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            this.recognition_capture_chart_total = res.data.data.total;
            this.recognition_capture_chart_past_total =
              res.data.data.past_total;

            let data = res.data.data.report_data;

            // If report Type is day
            if (this.report_type == "day") {
              data.map((val) => {
                let formatted_data = {
                  name: this.$moment(val.name).format("hh A"),
                  y: val.y,
                };

                this.recognition_capture_chart_data.push(formatted_data);
              });
            }
            // If report type is multiple days
            else if (this.report_type == "days") {
              data.map((val) => {
                let formatted_data = {
                  name: this.$moment(val.name).format("MMM DD"),
                  y: val.y,
                };
                this.recognition_capture_chart_data.push(formatted_data);
              });
            }
            //If report type is multiple months or multiple years
            else {
              this.recognition_capture_chart_data = data;
            }
          } else {
            this.recognition_capture_chart_total = 0;
            this.recognition_capture_chart_past_total = 0;
            this.recognition_capture_chart_data = [];
          }
          this.recognition_chart_loading = false;
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            this.recognition_chart_loading = true;
            return;
          }
          this.recognition_chart_loading = false;
          this.recognition_capture_chart_data = [];
        });
    },
    recognitionChartData() {
      this.recognition_chart_loading = true;
      this.recognition_capture_chart_total = 0;
      this.recognition_capture_chart_past_total = 0;
      this.recognition_capture_chart_data = [];

      if (this.recognition_capture_chart_source) {
        this.recognition_capture_chart_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.recognition_capture_chart_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/recognition-report",
          {
            from_date: this.$moment(this.from_date).format("YYYY-MM-DD HH:mm"),
            to_date: this.$moment(this.to_date).format("YYYY-MM-DD HH:mm"),
            time_zone: this.$moment.tz.guess(),
            type: this.report_type,
            property_id: this.selected_property_id,
            view_as_user: this.view_as_user,
          },
          {
            cancelToken: this.recognition_capture_chart_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            this.recognition_capture_chart_total = res.data.data.total;
            this.recognition_capture_chart_past_total =
              res.data.data.past_total;

            let data = res.data.data.report_data;

            // If report Type is day
            if (this.report_type == "day") {
              data.map((val) => {
                let formatted_data = {
                  name: this.$moment(val.name).format("hh A"),
                  y: val.y,
                };

                this.recognition_capture_chart_data.push(formatted_data);
              });
            }
            // If report type is multiple days
            else if (this.report_type == "days") {
              data.map((val) => {
                let formatted_data = {
                  name: this.$moment(val.name).format("MMM DD"),
                  y: val.y,
                };
                this.recognition_capture_chart_data.push(formatted_data);
              });
            }
            //If report type is multiple months or multiple years
            else {
              this.recognition_capture_chart_data = data;
            }
          } else {
            this.recognition_capture_chart_total = 0;
            this.recognition_capture_chart_past_total = 0;
            this.recognition_capture_chart_data = [];
          }
          this.recognition_chart_loading = false;
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            this.recognition_chart_loading = true;
            return;
          }
          this.recognition_chart_loading = false;
          this.recognition_capture_chart_data = [];
        });
    },
    confidenceChartData() {
      this.accuracy_chart_loading = true;
      this.accuracy_confidence_chart_total = 0;
      this.accuracy_confidence_chart_past_total = 0;
      this.accuracu_confidence_chart_data = [];

      if (this.accuracy_confidence_chart_source) {
        this.accuracy_confidence_chart_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.accuracy_confidence_chart_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/confidence-report",
          {
            from_date: this.$moment(this.from_date).format("YYYY-MM-DD HH:mm"),
            to_date: this.$moment(this.to_date).format("YYYY-MM-DD HH:mm"),
            time_zone: this.$moment.tz.guess(),
            type: this.report_type,
            property_id: this.selected_property_id,
          },
          {
            cancelToken: this.accuracy_confidence_chart_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            this.accuracy_confidence_chart_total = (
              res.data.data.total * 100
            ).toFixed(2);
            this.accuracy_confidence_chart_past_total = (
              res.data.data.past_total * 100
            ).toFixed(2);

            let data = res.data.data.report_data;

            // If report Type is day
            if (this.report_type == "day") {
              data.map((val) => {
                let formatted_data = {
                  name: this.$moment(val.name).format("hh A"),
                  y:
                    val.count > 0
                      ? this.roundToTwo((val.y / val.count) * 100)
                      : 0,
                };

                this.accuracu_confidence_chart_data.push(formatted_data);
              });
            }
            // If report type is multiple days
            else if (this.report_type == "days") {
              data.map((val) => {
                let formatted_data = {
                  name: this.$moment(val.name).format("MMM DD"),
                  y:
                    val.count > 0
                      ? this.roundToTwo((val.y / val.count) * 100)
                      : 0,
                };
                this.accuracu_confidence_chart_data.push(formatted_data);
              });
            }
            //If report type is multiple months or multiple years
            else {
              data.map((val) => {
                let formatted_data = {
                  name: val.name,
                  y:
                    val.count > 0
                      ? this.roundToTwo((val.y / val.count) * 100)
                      : 0,
                };

                this.accuracu_confidence_chart_data.push(formatted_data);
              });
            }
          } else {
            this.accuracy_confidence_chart_total = 0;
            this.accuracy_confidence_chart_past_total = 0;
            this.accuracu_confidence_chart_data = [];
          }
          this.accuracy_chart_loading = false;
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            this.accuracy_chart_loading = true;
            return;
          }
          this.accuracy_chart_loading = false;
          this.accuracu_confidence_chart_data = [];
        });
    },
    accuracyChartData() {
      this.accuracy_chart_loading = true;
      this.accuracy_confidence_chart_total = 0;
      this.accuracy_confidence_chart_past_total = 0;
      this.accuracu_confidence_chart_data = [];

      if (this.accuracy_confidence_chart_source) {
        this.accuracy_confidence_chart_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.accuracy_confidence_chart_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/accuracy-report",
          {
            from_date: this.$moment(this.from_date).format("YYYY-MM-DD HH:mm"),
            to_date: this.$moment(this.to_date).format("YYYY-MM-DD HH:mm"),
            time_zone: this.$moment.tz.guess(),
            type: this.report_type,
            property_id: this.selected_property_id,
            view_as_user: this.view_as_user,
          },
          {
            cancelToken: this.accuracy_confidence_chart_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            // console.log(res.data);
            let total_correct = res.data.data.total_correct;
            let total = res.data.data.total;
            this.accuracy_confidence_chart_total =
              total > 0 ? ((total_correct / total) * 100).toFixed() : 0;

            let past_total_correct = res.data.data.past_total_correct;
            let past_total = res.data.data.past_total;
            this.accuracy_confidence_chart_past_total =
              past_total > 0
                ? ((past_total_correct / past_total) * 100).toFixed()
                : 0;

            let data = res.data.data.report_data;

            // If report Type is day
            if (this.report_type == "day") {
              data.map((val) => {
                let formatted_data = {
                  name: this.$moment(val.name).format("hh A"),
                  y:
                    val.y > 0
                      ? this.roundToTwo((val.correct / val.y) * 100)
                      : 0,
                };

                this.accuracu_confidence_chart_data.push(formatted_data);
              });
            }
            // If report type is multiple days
            else if (this.report_type == "days") {
              data.map((val) => {
                let formatted_data = {
                  name: this.$moment(val.name).format("MMM DD"),
                  y:
                    val.y > 0
                      ? this.roundToTwo((val.correct / val.y) * 100)
                      : 0,
                };
                this.accuracu_confidence_chart_data.push(formatted_data);
              });
            }
            //If report type is multiple months or multiple years
            else {
              data.map((val) => {
                let formatted_data = {
                  name: val.name,
                  y:
                    val.y > 0
                      ? this.roundToTwo((val.correct / val.y) * 100)
                      : 0,
                };

                this.accuracu_confidence_chart_data.push(formatted_data);
              });
            }
          } else {
            this.accuracy_confidence_chart_total = 0;
            this.accuracy_confidence_chart_past_total = 0;
            this.accuracu_confidence_chart_data = [];
          }
          this.accuracy_chart_loading = false;
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            this.accuracy_chart_loading = true;
            return;
          }
          this.accuracy_chart_loading = false;
          this.accuracu_confidence_chart_data = [];
        });
    },
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    select_all() {
      this.check_all_audits = !this.check_all_audits;

      if (this.check_all_audits) {
        this.audit_list.map((audit) => {
          if (this.selected_audit_ids.indexOf(audit.id) === -1) {
            //this.selected_audit_ids.push(audit.id);
            this.checkAudit(audit);
          }
        });
      } else {
        this.selected_audit_ids = [];
        this.booking_id_list = [];
      }
    },
    sortBy(by, type) {
      this.sort_by = by;
      this.sort_type = type;
      this.audit_pagination.page = 1;
      this.audit_list = [];
      this.getAudits();
    },
    deleteBulkSession(){
      if(this.booking_id_list.length == 0){
        this.$toasted.show("Please select one of the audit listed!", {
          icon: "times-circle",
          className: "error-class",
        });
        return false;
      }
      this.$swal({
        title: "Are You Sure",
        html: `<p class="txt--ss font-weight-bold txt--off-white" >Are you sure you want to delete this session?</p>`,
        showCancelButton: true,
      }).then((res)=>{
          if(res.value){
            axios
            .post(window.hostname + "/api/auth/bulk-delete-session",{
              booking_id_list:this.booking_id_list
            }).then((res)=>{
              if(res.status){
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
              }
               //this.refresh();
               this.refreshAfterSessionDelete('bulk');
               this.check_all_audits = false;
            }).catch((err)=>{
              // console.log(err);
            });
          }        
      })        

    },
    confirmReprocess() 
    {
      this.$swal({
        title: "Are You Sure",
        html: `<p class="txt--ss font-weight-bold txt--off-white" >Are you sure you want to reprocess this audit?</p>`,
        showCancelButton: true,
      }).then((res)=> {
        if(res.value) {
          axios.post(window.hostname+'/api/auth/session-store-cron',{
            force_processing: true,
            id: this.audit_details.id
          })
          .then(result=> {
            if(result.status) {
              this.$toasted.show(result.data.message,{
                icon: "check-circle",
                className: "success-class"
              });
            }
            this.refresh();
          }).catch(err=> {
            // console.log(err);
          })
        }
      });
    },
  },
};
</script>

<style>
/* style the background and the text color of the input ... */
.vue-tags-input {
  border-radius: 16px !important;
  background: transparent !important;
  font-size: 12px !important;
  padding: 0 0.6rem !important;
  border: 1px solid hsla(0, 0%, 100%, 0.25) !important;
  max-width: 100% !important;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  color: hsla(0, 0%, 100%, 0.5);
}
.vue-tags-input.ti-focus {
  border-color: #f5a621 !important;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent !important;
  color: #b7c4c9;
}

.ti-input {
  border: 0 !important;
  padding: 4px 10px;
  transition: border-bottom 200ms ease;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #ebde6e;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #191919 !important;
  border: 0 !important;
  border-top: none !important;
  border-radius: 10px !important;
  width: 148px !important;
  top: 35px !important;
  padding-top: 10px !important;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item {
  color: #fff;
}
.vue-tags-input .ti-item.ti-selected-item {
  background-color: transparent;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative !important;
  background: transparent !important;
  color: #fff !important;
  align-items: center !important;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  left: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}
.ti-tag .ti-actions {
  background-color: rgba(255, 255, 255, 0.2) !important;
  font-size: 8px !important;
  justify-content: center !important;
  width: 13px !important;
  height: 13px !important;
  border-radius: 100% !important;
  color: rgba(255, 255, 255, 0.25) !important;
}
.date-range-time-class-audit .date__range__input .field.is-dark .field-input {
  width: 150px;
  padding: 0 10px;
}
.date-range-time-class-audit .time-picker::after,
.date-range-time-class-audit .time-picker::before {
  border-top: 0;
  border-bottom: 0;
}

@media (max-width: 460px) {
  .date-range-time-class-audit {
    flex-direction: column;
  }
  .date-range-time-class-audit .separator {
    display: none;
  }
  .date-range-time-class-audit .date__range__input {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>